// This file is generated by the get-ownership-info script. It automatically updates before each build.
export var fileOwnership = [
    {
        backendOwner: 'commerce-implement',
        framework: 'PlasmaReact',
        frontendOwner: 'commerce-implement',
        filePath: 'packages/jsadmin-commerce/src/Catalog/CatalogConfiguration/EditConfiguration/EditConfigurationPage.tsx',
        component: 'Page',
        parent: 'EditConfigurationPage',
        lineNumber: 13
    },
    {
        backendOwner: 'commerce-implement',
        framework: 'PlasmaReact',
        frontendOwner: 'commerce-implement',
        filePath: 'packages/jsadmin-commerce/src/Catalog/CatalogsPage.tsx',
        component: 'Page',
        parent: 'CatalogsPage',
        lineNumber: 17
    },
    {
        backendOwner: 'commerce-implement',
        framework: 'PlasmaReact',
        frontendOwner: 'commerce-implement',
        filePath: 'packages/jsadmin-commerce/src/Catalog/EditCatalog/EditCatalogPage.tsx',
        component: 'Page',
        parent: 'EditCatalogPage',
        lineNumber: 13
    },
    {
        backendOwner: 'index-infrastructure',
        framework: 'PlasmaReact',
        frontendOwner: 'platform-solution-experience',
        filePath: 'packages/jsadmin-log-browser/src/LogBrowserPage.tsx',
        component: 'Page',
        parent: 'LogBrowserPage',
        lineNumber: 9
    },
    {
        backendOwner: 'searchapi',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'packages/jsadmin-search-optimization/src/query-pipelines/QueryPipelinePage.tsx',
        component: 'TabsLayout.Panel',
        parent: 'QueryPipelinePageLayout',
        lineNumber: 53
    },
    {
        backendOwner: 'searchapi',
        framework: [
            'PlasmaReact',
            'Mantine'
        ],
        frontendOwner: 'platform-solution-experience',
        filePath: 'packages/jsadmin-search-optimization/src/query-pipelines/QueryPipelinePage.tsx',
        component: 'TabsLayout.Panel',
        parent: 'QueryPipelinePageLayout',
        lineNumber: 64
    },
    {
        backendOwner: 'searchapi',
        framework: [
            'PlasmaReact',
            'Mantine'
        ],
        frontendOwner: 'platform-solution-experience',
        filePath: 'packages/jsadmin-search-optimization/src/query-pipelines/QueryPipelinePage.tsx',
        component: 'TabsLayout.Panel',
        parent: 'QueryPipelinePageLayout',
        lineNumber: 75
    },
    {
        backendOwner: 'searchapi',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'packages/jsadmin-search-optimization/src/query-pipelines/QueryPipelinePage.tsx',
        component: 'TabsLayout.Panel',
        parent: 'QueryPipelinePageLayout',
        lineNumber: 87
    },
    {
        backendOwner: 'searchapi',
        framework: [
            'PlasmaReact',
            'Mantine'
        ],
        frontendOwner: 'platform-solution-experience',
        filePath: 'packages/jsadmin-search-optimization/src/query-pipelines/QueryPipelinePage.tsx',
        component: 'TabsLayout.Panel',
        parent: 'QueryPipelinePageLayout',
        lineNumber: 97
    },
    {
        backendOwner: 'searchapi',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'packages/jsadmin-search-optimization/src/query-pipelines/QueryPipelinePage.tsx',
        component: 'TabsLayout.Panel',
        parent: 'QueryPipelinePageLayout',
        lineNumber: 106
    },
    {
        backendOwner: 'ml-platform-building',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'packages/jsadmin-search-optimization/src/query-pipelines/QueryPipelinePage.tsx',
        component: 'TabsLayout.Panel',
        parent: 'QueryPipelinePageLayout',
        lineNumber: 119
    },
    {
        backendOwner: 'searchapi',
        framework: [
            'PlasmaReact',
            'Mantine'
        ],
        frontendOwner: 'platform-solution-experience',
        filePath: 'packages/jsadmin-search-optimization/src/query-pipelines/QueryPipelinePage.tsx',
        component: 'TabsLayout.Panel',
        parent: 'QueryPipelinePageLayout',
        lineNumber: 138
    },
    {
        backendOwner: 'searchapi',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'packages/jsadmin-search-optimization/src/query-pipelines/QueryPipelinePage.tsx',
        component: 'Page',
        parent: 'QueryPipelinePage',
        lineNumber: 155
    },
    {
        backendOwner: 'searchapi',
        framework: [
            'Mantine',
            'PlasmaReact'
        ],
        frontendOwner: 'platform-solution-experience',
        filePath: 'packages/jsadmin-search-optimization/src/query-pipelines/QueryPipelinesPage.tsx',
        component: 'Page',
        parent: 'QueryPipelinesPage',
        lineNumber: 16
    },
    {
        backendOwner: 'searchapi',
        framework: 'PlasmaReact',
        frontendOwner: 'platform-solution-experience',
        filePath: 'packages/jsadmin-search-optimization/src/statements/advanced/filters/edit/EditFilterPage.tsx',
        component: 'Page',
        parent: 'EditFilterPage',
        lineNumber: 18
    },
    {
        backendOwner: 'searchapi',
        framework: [
            'PlasmaReact',
            'Mantine'
        ],
        frontendOwner: 'platform-solution-experience',
        filePath: 'packages/jsadmin-search-optimization/src/statements/advanced/search-settings/edit/EditSearchSettingsPage.tsx',
        component: 'Page',
        parent: 'EditSearchSettingsPage',
        lineNumber: 17
    },
    {
        backendOwner: 'searchapi',
        framework: 'PlasmaReact',
        frontendOwner: 'platform-solution-experience',
        filePath: 'packages/jsadmin-search-optimization/src/statements/advanced/triggers/edit/EditTriggerPage.tsx',
        component: 'Page',
        parent: 'EditTriggerPage',
        lineNumber: 18
    },
    {
        backendOwner: 'searchapi',
        framework: 'PlasmaReact',
        frontendOwner: 'platform-solution-experience',
        filePath: 'packages/jsadmin-search-optimization/src/statements/edit-code/EditStatementCodePage.tsx',
        component: 'Page',
        parent: 'EditStatementCodePage',
        lineNumber: 56
    },
    {
        backendOwner: 'searchapi',
        framework: [
            'Mantine',
            'PlasmaReact'
        ],
        frontendOwner: 'platform-solution-experience',
        filePath: 'packages/jsadmin-search-optimization/src/statements/result-ranking/edit/ResultRankingConfigurationPage.tsx',
        component: 'Page',
        parent: 'ResultRankingConfigurationPage',
        lineNumber: 17
    },
    {
        backendOwner: 'searchapi',
        framework: 'PlasmaReact',
        frontendOwner: 'platform-solution-experience',
        filePath: 'packages/jsadmin-search-optimization/src/statements/result-ranking/edit/featured-results/FeaturedResultsJSONEditorPage.tsx',
        component: 'Page',
        parent: 'FeaturedResultsJSONEditorPage',
        lineNumber: 15
    },
    {
        backendOwner: 'searchapi',
        framework: 'PlasmaReact',
        frontendOwner: 'platform-solution-experience',
        filePath: 'packages/jsadmin-search-optimization/src/statements/search-terms/synonyms/edit/EditSynonymPage.tsx',
        component: 'Page',
        parent: 'EditSynonymPage',
        lineNumber: 17
    },
    {
        backendOwner: 'searchapi',
        framework: 'PlasmaReact',
        frontendOwner: 'platform-solution-experience',
        filePath: 'packages/jsadmin-search-optimization/src/statements/statement-groups/configuration/StatementGroupConfigurationPage.tsx',
        component: 'Page',
        parent: 'StatementGroupConfigurationPage',
        lineNumber: 15
    },
    {
        backendOwner: 'knowledge-core',
        framework: 'Mantine',
        frontendOwner: 'knowledge-hub',
        filePath: 'packages/jsadmin-service/src/caseAssist/CaseAssistPage.tsx',
        component: 'Page',
        parent: 'CaseAssistPage',
        lineNumber: 15
    },
    {
        backendOwner: 'knowledge-core',
        framework: [
            'Mantine',
            'PlasmaReact'
        ],
        frontendOwner: 'knowledge-hub',
        filePath: 'packages/jsadmin-service/src/caseAssist/EditCaseAssistPage.tsx',
        component: 'Page',
        parent: 'EditCaseAssistPage',
        lineNumber: 13
    },
    {
        backendOwner: 'knowledge-core',
        framework: 'Mantine',
        frontendOwner: 'knowledge-hub',
        filePath: 'packages/jsadmin-service/src/caseAssist/createCaseAssistConfig/CreateCaseAssistConfigModal.tsx',
        component: 'Modal',
        parent: 'CreateCaseAssistConfigModal',
        lineNumber: 139
    },
    {
        backendOwner: 'knowledge-core',
        framework: [
            'Mantine',
            'PlasmaReact'
        ],
        frontendOwner: 'knowledge-hub',
        filePath: 'packages/jsadmin-service/src/insightPanel/EditInsightPanelPage.tsx',
        component: 'Page',
        parent: 'EditInsightPanelPage',
        lineNumber: 10
    },
    {
        backendOwner: 'knowledge-core',
        framework: [
            'Mantine',
            'PlasmaReact'
        ],
        frontendOwner: 'knowledge-hub',
        filePath: 'packages/jsadmin-service/src/insightPanel/InsightPanelPage.tsx',
        component: 'Page',
        parent: 'InsightPanelPage',
        lineNumber: 17
    },
    {
        backendOwner: 'knowledge-core',
        framework: 'Mantine',
        frontendOwner: 'knowledge-hub',
        filePath: 'packages/jsadmin-service/src/insightPanel/duplicateInsightPanelConfig/DuplicateInsightPanelConfigModal.tsx',
        component: 'Modal',
        parent: 'DuplicateInsightPanelConfigModal',
        lineNumber: 106
    },
    {
        backendOwner: 'knowledge-core',
        framework: 'Mantine',
        frontendOwner: 'knowledge-hub',
        filePath: 'packages/jsadmin-service/src/insightPanel/editInsightPanelConfig/InterfaceNotFoundModal.tsx',
        component: 'Modal',
        parent: 'InterfaceNotFoundModal',
        lineNumber: 12
    },
    {
        backendOwner: 'dataplatformfoundation',
        framework: 'Backbone',
        frontendOwner: 'platform-solution-experience',
        filePath: 'packages/jsadmin-usage-analytics/src/components/Dashboard/DashboardPage.tsx',
        component: 'Page',
        parent: 'DashboardPage',
        lineNumber: 17
    },
    {
        backendOwner: 'dataplatformfoundation',
        framework: 'Backbone',
        frontendOwner: 'platform-solution-experience',
        filePath: 'packages/jsadmin-usage-analytics/src/components/Dashboard/DashboardPage.tsx',
        component: 'BackboneWrapper',
        parent: 'DashboardPage',
        lineNumber: 24
    },
    {
        backendOwner: 'dataplatformfoundation',
        framework: 'Backbone',
        frontendOwner: 'platform-solution-experience',
        filePath: 'packages/jsadmin-usage-analytics/src/components/Dashboard/DashboardPage.tsx',
        component: 'BackboneWrapper',
        parent: 'DashboardPage',
        lineNumber: 42
    },
    {
        backendOwner: 'dataplatformfoundation',
        framework: 'Backbone',
        frontendOwner: 'platform-solution-experience',
        filePath: 'packages/jsadmin-usage-analytics/src/components/Explorer/ExplorerPage.tsx',
        component: 'Page',
        parent: 'ExplorerPage',
        lineNumber: 15
    },
    {
        backendOwner: 'dataplatformfoundation',
        framework: 'Backbone',
        frontendOwner: 'platform-solution-experience',
        filePath: 'packages/jsadmin-usage-analytics/src/components/Explorer/ExplorerPage.tsx',
        component: 'BackboneWrapper',
        parent: 'ExplorerPage',
        lineNumber: 22
    },
    {
        backendOwner: 'dataplatformfoundation',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'packages/jsadmin-usage-analytics/src/components/Reports/EditReportJSONModal.tsx',
        component: 'Modal',
        parent: 'EditReportJSONModal',
        lineNumber: 80
    },
    {
        backendOwner: 'dataplatformfoundation',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'packages/jsadmin-usage-analytics/src/components/Reports/ReportsPage.tsx',
        component: 'Page',
        parent: 'ReportsPage',
        lineNumber: 16
    },
    {
        backendOwner: 'dataplatformfoundation',
        framework: 'Backbone',
        frontendOwner: 'platform-solution-experience',
        filePath: 'packages/jsadmin-usage-analytics/src/components/VisitBrowser/VisitBrowserBackbonePage.tsx',
        component: 'Page',
        parent: 'VisitBrowserBackbonePage',
        lineNumber: 17
    },
    {
        backendOwner: 'dataplatformfoundation',
        framework: 'Backbone',
        frontendOwner: 'platform-solution-experience',
        filePath: 'packages/jsadmin-usage-analytics/src/components/VisitBrowser/VisitBrowserBackbonePage.tsx',
        component: 'BackboneWrapper',
        parent: 'VisitBrowserBackbonePage',
        lineNumber: 24
    },
    {
        backendOwner: 'index-querying',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'packages/v2/src/fields/FieldsPage.tsx',
        component: 'Page',
        parent: 'FieldsPage',
        lineNumber: 10
    },
    {
        backendOwner: 'index-querying',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'packages/v2/src/fields/edit/EditFieldPage.tsx',
        component: 'Page',
        parent: 'EditFieldPage',
        lineNumber: 43
    },
    {
        backendOwner: 'platform-identity-and-entitlements',
        framework: 'Mantine',
        frontendOwner: 'platform-identity-and-entitlements',
        filePath: 'packages/v2/src/groups/GroupsPage.tsx',
        component: 'Page',
        parent: 'GroupsPage',
        lineNumber: 10
    },
    {
        backendOwner: 'platform-identity-and-entitlements',
        framework: [
            'Mantine',
            'PlasmaReact'
        ],
        frontendOwner: 'platform-identity-and-entitlements',
        filePath: 'packages/v2/src/groups/edit-group/AddGroupPage.tsx',
        component: 'Page',
        parent: 'AddGroupPage',
        lineNumber: 45
    },
    {
        backendOwner: 'platform-identity-and-entitlements',
        framework: [
            'Mantine',
            'PlasmaReact'
        ],
        frontendOwner: 'platform-identity-and-entitlements',
        filePath: 'packages/v2/src/groups/edit-group/EditGroupPage.tsx',
        component: 'Page',
        parent: 'EditGroupPage',
        lineNumber: 53
    },
    {
        backendOwner: 'platform-identity-and-entitlements',
        framework: [
            'Mantine',
            'PlasmaReact'
        ],
        frontendOwner: 'platform-identity-and-entitlements',
        filePath: 'packages/v2/src/notifications/NotificationsPage.tsx',
        component: 'Page',
        parent: 'NotificationsPage',
        lineNumber: 23
    },
    {
        backendOwner: 'platform-identity-and-entitlements',
        framework: [
            'Mantine',
            'PlasmaReact'
        ],
        frontendOwner: 'platform-identity-and-entitlements',
        filePath: 'packages/v2/src/organization-members/MembersPage.tsx',
        component: 'Page',
        parent: 'MembersPage',
        lineNumber: 12
    },
    {
        backendOwner: 'platform-identity-and-entitlements',
        framework: [
            'Mantine',
            'PlasmaReact'
        ],
        frontendOwner: 'platform-identity-and-entitlements',
        filePath: 'packages/v2/src/organizations/OrganizationsPage.tsx',
        component: 'Page',
        parent: 'OrganizationsPage',
        lineNumber: 16
    },
    {
        backendOwner: 'platform-identity-and-entitlements',
        framework: 'Mantine',
        frontendOwner: 'platform-identity-and-entitlements',
        filePath: 'packages/v2/src/organizations/add/AddTestOrganizationPage.tsx',
        component: 'Page',
        parent: 'AddTestOrganizationPage',
        lineNumber: 10
    },
    {
        backendOwner: 'platform-identity-and-entitlements',
        framework: [
            'Mantine',
            'PlasmaReact'
        ],
        frontendOwner: 'platform-identity-and-entitlements',
        filePath: 'packages/v2/src/organizations/restore/RestoreOrganizationPage.tsx',
        component: 'Page',
        parent: 'RestoreOrganizationPage',
        lineNumber: 9
    },
    {
        backendOwner: 'platform-resource-insight',
        framework: [
            'Mantine',
            'PlasmaReact'
        ],
        frontendOwner: 'platform-resource-insight',
        filePath: 'packages/v2/src/resource-snapshots/ResourceSnapshotsPage.tsx',
        component: 'Page',
        parent: 'ResourcesSnapshotPage',
        lineNumber: 41
    },
    {
        backendOwner: 'service-integrations',
        framework: 'Mantine',
        frontendOwner: 'service-integrations',
        filePath: 'packages/v2/src/search-interfaces/components/cli/HostedPageCliDeployModal.tsx',
        component: 'ModalWizard',
        parent: 'HostedPageCliDeployModal',
        lineNumber: 67
    },
    {
        backendOwner: 'service-integrations',
        framework: 'Mantine',
        frontendOwner: 'service-integrations',
        filePath: 'packages/v2/src/search-interfaces/components/create/CreateSearchInterfaceV2Modal.tsx',
        component: 'Modal',
        parent: 'CreateSearchInterfaceV2Modal',
        lineNumber: 50
    },
    {
        backendOwner: 'platform-identity-and-entitlements',
        framework: [
            'Mantine',
            'PlasmaReact'
        ],
        frontendOwner: 'platform-identity-and-entitlements',
        filePath: 'packages/v2/src/settings-react/SettingsPage.tsx',
        component: 'Page',
        parent: 'SettingsPage',
        lineNumber: 19
    },
    {
        backendOwner: 'dataplatformfoundation',
        framework: [
            'Mantine',
            'PlasmaReact'
        ],
        frontendOwner: 'platform-solution-experience',
        filePath: 'packages/v2/src/settings-react/analytics/AnalyticsSettingsLayout.tsx',
        component: 'SubnavLayout.Panel',
        parent: 'AnalyticsSettingsLayout',
        lineNumber: 11
    },
    {
        backendOwner: 'platform-identity-and-entitlements',
        framework: [
            'Mantine',
            'PlasmaReact'
        ],
        frontendOwner: 'platform-identity-and-entitlements',
        filePath: 'packages/v2/src/settings-react/coveo-only/CoveoOnlySettingsLayout.tsx',
        component: 'SubnavLayout.Panel',
        parent: 'CoveoOnlySettingsLayout',
        lineNumber: 14
    },
    {
        backendOwner: 'platform-identity-and-entitlements',
        framework: [
            'Mantine',
            'PlasmaReact'
        ],
        frontendOwner: 'platform-identity-and-entitlements',
        filePath: 'packages/v2/src/settings-react/coveo-only/CoveoOnlySettingsLayout.tsx',
        component: 'SubnavLayout.Panel',
        parent: 'CoveoOnlySettingsLayout',
        lineNumber: 24
    },
    {
        backendOwner: 'platform-identity-and-entitlements',
        framework: [
            'Mantine',
            'PlasmaReact'
        ],
        frontendOwner: 'platform-identity-and-entitlements',
        filePath: 'packages/v2/src/settings-react/coveo-only/CoveoOnlySettingsLayout.tsx',
        component: 'SubnavLayout.Panel',
        parent: 'CoveoOnlySettingsLayout',
        lineNumber: 33
    },
    {
        backendOwner: 'platform-identity-and-entitlements',
        framework: [
            'Mantine'
        ],
        frontendOwner: 'platform-identity-and-entitlements',
        filePath: 'packages/v2/src/settings-react/coveo-only/CoveoOnlySettingsLayout.tsx',
        component: 'SubnavLayout.Panel',
        parent: 'CoveoOnlySettingsLayout',
        lineNumber: 42
    },
    {
        backendOwner: 'platform-identity-and-entitlements',
        framework: 'Mantine',
        frontendOwner: 'platform-identity-and-entitlements',
        filePath: 'packages/v2/src/settings-react/coveo-only/details/OverrideConfigurationModal.tsx',
        component: 'Modal',
        parent: 'OverrideConfigurationModal',
        lineNumber: 187
    },
    {
        backendOwner: 'platform-identity-and-entitlements',
        framework: 'Mantine',
        frontendOwner: 'platform-identity-and-entitlements',
        filePath: 'packages/v2/src/settings-react/coveo-only/details/OverrideGroupConfigurationModal.tsx',
        component: 'Modal',
        parent: 'OverrideGroupConfigurationModal',
        lineNumber: 132
    },
    {
        backendOwner: 'platform-identity-and-entitlements',
        framework: 'Mantine',
        frontendOwner: 'platform-identity-and-entitlements',
        filePath: 'packages/v2/src/settings-react/license/LicenseSettingsLayout.tsx',
        component: 'SubnavLayout.Panel',
        parent: 'LicenseSettingsLayout',
        lineNumber: 16
    },
    {
        backendOwner: 'searchapi',
        framework: [
            'Mantine',
            'PlasmaReact'
        ],
        frontendOwner: 'platform-solution-experience',
        filePath: 'packages/v2/src/settings-react/license/LicenseSettingsLayout.tsx',
        component: 'SubnavLayout.Panel',
        parent: 'LicenseSettingsLayout',
        lineNumber: 26
    },
    {
        backendOwner: 'platform-identity-and-entitlements',
        framework: 'Mantine',
        frontendOwner: 'platform-identity-and-entitlements',
        filePath: 'packages/v2/src/settings-react/license/LicenseSettingsLayout.tsx',
        component: 'SubnavLayout.Panel',
        parent: 'LicenseSettingsLayout',
        lineNumber: 49
    },
    {
        backendOwner: 'platform-identity-and-entitlements',
        framework: [
            'Mantine',
            'PlasmaReact'
        ],
        frontendOwner: 'platform-identity-and-entitlements',
        filePath: 'packages/v2/src/settings-react/organization/OrganizationSettings.tsx',
        component: 'SubnavLayout.Panel',
        parent: 'OrganizationSettings',
        lineNumber: 14
    },
    {
        backendOwner: 'platform-identity-and-entitlements',
        framework: [
            'Mantine',
            'PlasmaReact'
        ],
        frontendOwner: 'platform-identity-and-entitlements',
        filePath: 'packages/v2/src/settings-react/organization/OrganizationSettings.tsx',
        component: 'SubnavLayout.Panel',
        parent: 'OrganizationSettings',
        lineNumber: 24
    },
    {
        backendOwner: 'platform-identity-and-entitlements',
        framework: 'Mantine',
        frontendOwner: 'platform-identity-and-entitlements',
        filePath: 'packages/v2/src/settings-react/organization/OrganizationSettings.tsx',
        component: 'SubnavLayout.Panel',
        parent: 'OrganizationSettings',
        lineNumber: 33
    },
    {
        backendOwner: 'platform-identity-and-entitlements',
        framework: [
            'Mantine',
            'PlasmaReact'
        ],
        frontendOwner: 'platform-identity-and-entitlements',
        filePath: 'packages/v2/src/settings-react/organization/OrganizationSettings.tsx',
        component: 'SubnavLayout.Panel',
        parent: 'OrganizationSettings',
        lineNumber: 42
    },
    {
        backendOwner: 'index-infrastructure',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'packages/v2/src/settings-react/organization/OrganizationSettings.tsx',
        component: 'SubnavLayout.Panel',
        parent: 'OrganizationSettings',
        lineNumber: 52
    },
    {
        backendOwner: 'platform-identity-and-entitlements',
        framework: 'Mantine',
        frontendOwner: 'platform-identity-and-entitlements',
        filePath: 'packages/v2/src/settings-react/organization/traffic-monitoring/AnalyticsSearchHubUsageModal.tsx',
        component: 'Modal',
        parent: 'AnalyticsSearchHubUsageModal',
        lineNumber: 119
    },
    {
        backendOwner: 'platform-identity-and-entitlements',
        framework: 'Mantine',
        frontendOwner: 'platform-identity-and-entitlements',
        filePath: 'packages/v2/src/settings-react/organization/traffic-monitoring/SearchHubUsageModal.tsx',
        component: 'Modal',
        parent: 'SearchHubUsageModal',
        lineNumber: 87
    },
    {
        backendOwner: 'connectivity-core',
        framework: 'Backbone',
        frontendOwner: 'platform-solution-experience',
        filePath: 'packages/v2/src/sources/SourcesPage.tsx',
        component: 'BackboneWrapper',
        parent: 'DuplicateSourceModal',
        lineNumber: 138
    },
    {
        backendOwner: 'connectivity-core',
        framework: 'Backbone',
        frontendOwner: 'platform-solution-experience',
        filePath: 'packages/v2/src/sources/SourcesPage.tsx',
        component: 'BackboneWrapper',
        parent: 'SourceMappingModal',
        lineNumber: 157
    },
    {
        backendOwner: 'connectivity-core',
        framework: 'Backbone',
        frontendOwner: 'platform-solution-experience',
        filePath: 'packages/v2/src/sources/SourcesPage.tsx',
        component: 'BackboneWrapper',
        parent: 'EditSourceExtensionModal',
        lineNumber: 180
    },
    {
        backendOwner: 'connectivity-core',
        framework: 'Backbone',
        frontendOwner: 'platform-solution-experience',
        filePath: 'packages/v2/src/sources/SourcesPage.tsx',
        component: 'BackboneWrapper',
        parent: 'EditSourceModal',
        lineNumber: 238
    },
    {
        backendOwner: 'connectivity-core',
        framework: 'Backbone',
        frontendOwner: 'platform-solution-experience',
        filePath: 'packages/v2/src/sources/SourcesPage.tsx',
        component: 'BackboneWrapper',
        parent: 'AuthorizeOAuthSourceHandler',
        lineNumber: 260
    },
    {
        backendOwner: 'connectivity-core',
        framework: 'Backbone',
        frontendOwner: 'platform-solution-experience',
        filePath: 'packages/v2/src/sources/SourcesPage.tsx',
        component: 'BackboneWrapper',
        parent: 'EditOAuthSource',
        lineNumber: 273
    },
    {
        backendOwner: 'connectivity-core',
        framework: 'PlasmaReact',
        frontendOwner: 'platform-solution-experience',
        filePath: 'packages/v2/src/sources/edit/EditReactSourcePage.tsx',
        component: 'Page',
        parent: 'EditReactSourcePage',
        lineNumber: 68
    },
    {
        backendOwner: 'ctinfra',
        framework: [
            'Mantine',
            'PlasmaReact',
            'Backbone'
        ],
        frontendOwner: 'platform-solution-experience',
        filePath: 'packages/v2/src/sources/metadata/MetadataPage.tsx',
        component: 'Page',
        parent: 'MetadataPage',
        lineNumber: 13
    },
    {
        backendOwner: 'connectivity-core',
        framework: 'Backbone',
        frontendOwner: 'platform-solution-experience',
        filePath: 'packages/v2/src/sources/metadata/modal/MetadataViewMappingsModal.tsx',
        component: 'BackboneWrapper',
        parent: 'MetadataViewMappingsModal',
        lineNumber: 12
    },
    {
        backendOwner: 'platform-identity-and-entitlements',
        framework: 'PlasmaReact',
        frontendOwner: 'platform-identity-and-entitlements',
        filePath: 'packages/v2/src/sources/notifications/SourceNotificationsPage.tsx',
        component: 'Page',
        parent: 'SourceNotificationsPage',
        lineNumber: 36
    },
    {
        backendOwner: 'platform-identity-and-entitlements',
        framework: [
            'Mantine',
            'PlasmaReact'
        ],
        frontendOwner: 'platform-identity-and-entitlements',
        filePath: 'packages/v2/src/temporary-access/TemporaryAccessPage.tsx',
        component: 'Page',
        parent: 'TemporaryAccessPage',
        lineNumber: 17
    },
    {
        backendOwner: 'platform-solution-experience',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'components/conditions/src/components/select-condition/CreateConditionModal.tsx',
        component: 'Modal',
        parent: 'CreateConditionModalContent',
        lineNumber: 62
    },
    {
        backendOwner: 'frontend-foundation',
        framework: 'Mantine',
        frontendOwner: 'frontend-foundation',
        filePath: 'components/navigation/src/components/bug-reporter/BugReportModal.tsx',
        component: 'Modal',
        parent: 'BugReportModal',
        lineNumber: 31
    },
    {
        backendOwner: 'Shared',
        framework: 'Mantine',
        frontendOwner: 'frontend-foundation',
        filePath: 'components/pages-flow/src/components/list-page/ListPage.tsx',
        component: 'Page',
        parent: 'ListPage',
        lineNumber: 59
    },
    {
        backendOwner: 'connectivity-core',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'components/user-feedback/src/components/user-feedback-slack-channel/UserFeedbackSlackChannelModal.tsx',
        component: 'Modal',
        parent: 'UserFeedbackSlackChannelModalInner',
        lineNumber: 170
    },
    {
        backendOwner: 'platform-resource-insight',
        framework: 'Mantine',
        frontendOwner: 'platform-resource-insight',
        filePath: 'pages/activity-browser/src/components/modal/ActivityBrowserModal.tsx',
        component: 'Modal',
        parent: 'ActivityBrowserModal',
        lineNumber: 29
    },
    {
        backendOwner: 'platform-resource-insight',
        framework: 'Mantine',
        frontendOwner: 'platform-resource-insight',
        filePath: 'pages/activity-browser/src/pages/ActivityBrowserPage.tsx',
        component: 'Page',
        parent: 'ActivityBrowserPage',
        lineNumber: 7
    },
    {
        backendOwner: 'dataplatformfoundation',
        framework: 'Mantine',
        frontendOwner: 'commerce-administrators',
        filePath: 'pages/advanced-reports/src/components/AdvancedReportsPage.tsx',
        component: 'Page',
        parent: 'AdvancedReportsPage',
        lineNumber: 26
    },
    {
        backendOwner: 'dataplatformfoundation',
        framework: 'Mantine',
        frontendOwner: 'commerce-administrators',
        filePath: 'pages/advanced-reports/src/components/reporting-cards/TableViewMore.tsx',
        component: 'Modal',
        parent: 'TableViewMore',
        lineNumber: 66
    },
    {
        backendOwner: 'knowledge-core',
        framework: 'Mantine',
        frontendOwner: 'knowledge-hub',
        filePath: 'pages/agentic/src/pages/AgentCreationPage.tsx',
        component: 'Page',
        parent: 'AgentCreationPage',
        lineNumber: 9
    },
    {
        backendOwner: 'knowledge-core',
        framework: 'Mantine',
        frontendOwner: 'knowledge-hub',
        filePath: 'pages/agentic/src/pages/AgentEditPage.tsx',
        component: 'Page',
        parent: 'AgentEditPage',
        lineNumber: 145
    },
    {
        backendOwner: 'knowledge-core',
        framework: 'Mantine',
        frontendOwner: 'knowledge-hub',
        filePath: 'pages/agentic/src/pages/AgentViewPage.tsx',
        component: 'Page',
        parent: 'AgentViewPage',
        lineNumber: 82
    },
    {
        backendOwner: 'knowledge-core',
        framework: 'Mantine',
        frontendOwner: 'knowledge-hub',
        filePath: 'pages/agentic/src/pages/AgentsListPage.tsx',
        component: 'Page',
        parent: 'AgentsListPage',
        lineNumber: 35
    },
    {
        backendOwner: 'platform-resource-insight',
        framework: 'Mantine',
        frontendOwner: 'platform-resource-insight',
        filePath: 'pages/announcements/src/pages/AnnouncementsAddPage.tsx',
        component: 'Page',
        parent: 'AnnouncementsAddPage',
        lineNumber: 45
    },
    {
        backendOwner: 'platform-resource-insight',
        framework: 'Mantine',
        frontendOwner: 'platform-resource-insight',
        filePath: 'pages/announcements/src/pages/AnnouncementsListPage.tsx',
        component: 'Page',
        parent: 'AnnouncementsListPage',
        lineNumber: 14
    },
    {
        backendOwner: 'knowledge-core',
        framework: 'Mantine',
        frontendOwner: 'knowledge-hub',
        filePath: 'pages/answer-manager/src/pages/answer-configurations/AnswerConfigEditCreateModal.tsx',
        component: 'Modal',
        parent: 'AnswerConfigCreateModal',
        lineNumber: 98
    },
    {
        backendOwner: 'knowledge-core',
        framework: 'Mantine',
        frontendOwner: 'knowledge-hub',
        filePath: 'pages/answer-manager/src/pages/answer-configurations/AnswerConfigPage.tsx',
        component: 'Page',
        parent: 'AnswerConfigPage',
        lineNumber: 11
    },
    {
        backendOwner: 'knowledge-core',
        framework: 'Mantine',
        frontendOwner: 'knowledge-hub',
        filePath: 'pages/answer-manager/src/pages/answer-evaluations/AnswerEvaluationPage.tsx',
        component: 'Page',
        parent: 'AnswerEvaluationPage',
        lineNumber: 10
    },
    {
        backendOwner: 'knowledge-core',
        framework: 'Mantine',
        frontendOwner: 'knowledge-hub',
        filePath: 'pages/answer-manager/src/pages/answer-manager/AnswerManagerPage.tsx',
        component: 'Page',
        parent: 'AnswerManagerPage',
        lineNumber: 20
    },
    {
        backendOwner: 'knowledge-core',
        framework: 'Mantine',
        frontendOwner: 'knowledge-hub',
        filePath: 'pages/answer-manager/src/pages/answer-rules/AnswerRuleEditCreateModal.tsx',
        component: 'Modal',
        parent: 'AnswerRuleEditCreateModal',
        lineNumber: 152
    },
    {
        backendOwner: 'knowledge-core',
        framework: 'Mantine',
        frontendOwner: 'knowledge-hub',
        filePath: 'pages/answer-manager/src/pages/answer-rules/AnswerRulePage.tsx',
        component: 'Page',
        parent: 'AnswerRulesPage',
        lineNumber: 18
    },
    {
        backendOwner: 'knowledge-core',
        framework: 'Mantine',
        frontendOwner: 'knowledge-hub',
        filePath: 'pages/batch-answer-evaluation/src/pages/evaluation-creation/EvaluationCreation.tsx',
        component: 'Page',
        parent: 'EvaluationCreation',
        lineNumber: 18
    },
    {
        backendOwner: 'knowledge-core',
        framework: 'Mantine',
        frontendOwner: 'knowledge-hub',
        filePath: 'pages/batch-answer-evaluation/src/pages/evaluation-list/EvaluationRenameModal.tsx',
        component: 'Modal.Root',
        parent: 'EvaluationRenameModal',
        lineNumber: 131
    },
    {
        backendOwner: 'knowledge-core',
        framework: 'Mantine',
        frontendOwner: 'knowledge-hub',
        filePath: 'pages/batch-answer-evaluation/src/pages/evaluation-list/EvaluationsListPage.tsx',
        component: 'Page',
        parent: 'EvaluationsListPage',
        lineNumber: 31
    },
    {
        backendOwner: 'knowledge-core',
        framework: 'Mantine',
        frontendOwner: 'knowledge-hub',
        filePath: 'pages/batch-answer-evaluation/src/pages/evaluation-run/EvaluationRun.tsx',
        component: 'Page',
        parent: 'EvaluationRun',
        lineNumber: 11
    },
    {
        backendOwner: 'knowledge-core',
        framework: 'Mantine',
        frontendOwner: 'knowledge-hub',
        filePath: 'pages/batch-answer-evaluation/src/pages/evaluation-runs-list/EvaluationRunNewModal.tsx',
        component: 'Modal',
        parent: 'EvaluationRunNewModal',
        lineNumber: 56
    },
    {
        backendOwner: 'knowledge-core',
        framework: 'Mantine',
        frontendOwner: 'knowledge-hub',
        filePath: 'pages/batch-answer-evaluation/src/pages/evaluation-runs-list/EvaluationRunsListPage.tsx',
        component: 'Page',
        parent: 'EvaluationRunsListPage',
        lineNumber: 57
    },
    {
        backendOwner: 'frontend-foundation',
        framework: 'Mantine',
        frontendOwner: 'frontend-foundation',
        filePath: 'pages/boundaries/src/pages/error/ErrorPage.tsx',
        component: 'Page',
        parent: 'ErrorPage',
        lineNumber: 7
    },
    {
        backendOwner: 'frontend-foundation',
        framework: 'Mantine',
        frontendOwner: 'frontend-foundation',
        filePath: 'pages/boundaries/src/pages/insufficient-privileges/InsufficientPrivilegesPage.tsx',
        component: 'SplashPage',
        parent: 'InsufficientPrivilegesInnerPage',
        lineNumber: 36
    },
    {
        backendOwner: 'frontend-foundation',
        framework: 'Mantine',
        frontendOwner: 'frontend-foundation',
        filePath: 'pages/boundaries/src/pages/invites/InvitesPage.tsx',
        component: 'SplashPage',
        parent: 'InvitesPage',
        lineNumber: 104
    },
    {
        backendOwner: 'frontend-foundation',
        framework: 'Mantine',
        frontendOwner: 'frontend-foundation',
        filePath: 'pages/boundaries/src/pages/no-organization/NoOrganizationPage.tsx',
        component: 'SplashPage',
        parent: 'NoOrganizationPage',
        lineNumber: 36
    },
    {
        backendOwner: 'frontend-foundation',
        framework: 'Mantine',
        frontendOwner: 'frontend-foundation',
        filePath: 'pages/boundaries/src/pages/not-found/NotFoundPage.tsx',
        component: 'Page',
        parent: 'NotFoundPage',
        lineNumber: 15
    },
    {
        backendOwner: 'frontend-foundation',
        framework: 'Mantine',
        frontendOwner: 'frontend-foundation',
        filePath: 'pages/boundaries/src/pages/unable-to-load/UnableToLoadPage.tsx',
        component: 'SplashPage',
        parent: 'UnableToLoadPage',
        lineNumber: 70
    },
    {
        backendOwner: 'knowledge-core',
        framework: 'Mantine',
        frontendOwner: 'knowledge-hub',
        filePath: 'pages/chunk-inspector/src/pages/ChunkInspectorPage.tsx',
        component: 'Page',
        parent: 'ChunkInspectorPage',
        lineNumber: 58
    },
    {
        backendOwner: 'commerce-administrators',
        framework: 'Mantine',
        frontendOwner: 'commerce-administrators',
        filePath: 'pages/commerce-health/src/pages/EventHealthDetailsPage.tsx',
        component: 'Page',
        parent: 'EventHealthDetailsPage',
        lineNumber: 58
    },
    {
        backendOwner: 'commerce-administrators',
        framework: 'Mantine',
        frontendOwner: 'commerce-administrators',
        filePath: 'pages/commerce-health/src/pages/FeatureHealthDetailsPage.tsx',
        component: 'Page',
        parent: 'FeatureHealthDetailsPage',
        lineNumber: 49
    },
    {
        backendOwner: 'commerce-administrators',
        framework: 'Mantine',
        frontendOwner: 'commerce-administrators',
        filePath: 'pages/commerce-health/src/pages/FieldHealthDetailsPage.tsx',
        component: 'Page',
        parent: 'FieldHealthDetailsPage',
        lineNumber: 93
    },
    {
        backendOwner: 'commerce-administrators',
        framework: 'Mantine',
        frontendOwner: 'commerce-administrators',
        filePath: 'pages/commerce-health/src/pages/HealthPage.tsx',
        component: 'Page',
        parent: 'HealthPage',
        lineNumber: 110
    },
    {
        backendOwner: 'commerce-administrators',
        framework: 'Mantine',
        frontendOwner: 'commerce-administrators',
        filePath: 'pages/commerce-health/src/pages/RuleHealthDetailsPage.tsx',
        component: 'Page',
        parent: 'RuleHealthDetailsPage',
        lineNumber: 189
    },
    {
        backendOwner: 'commerce-administrators',
        framework: 'Mantine',
        frontendOwner: 'commerce-administrators',
        filePath: 'pages/commerce-hub/src/components/badging/BadgeCreationConfirmationModal.tsx',
        component: 'Modal',
        parent: 'BadgeCreatedModal',
        lineNumber: 43
    },
    {
        backendOwner: 'commerce-administrators',
        framework: 'Mantine',
        frontendOwner: 'commerce-administrators',
        filePath: 'pages/commerce-hub/src/components/badging/badge-priority-per-placement/priority-in-placement-modal/PriorityInPlacementModal.tsx',
        component: 'Modal',
        parent: 'PriorityInPlacementModal',
        lineNumber: 36
    },
    {
        backendOwner: 'commerce-administrators',
        framework: 'Mantine',
        frontendOwner: 'commerce-administrators',
        filePath: 'pages/commerce-hub/src/components/component/audiences/AudiencePicker.tsx',
        component: 'Modal',
        parent: 'AudiencePicker',
        lineNumber: 60
    },
    {
        backendOwner: 'commerce-administrators',
        framework: 'Mantine',
        frontendOwner: 'commerce-administrators',
        filePath: 'pages/commerce-hub/src/components/component/audiences/CustomAudienceModal.tsx',
        component: 'Modal',
        parent: 'CustomAudienceModal',
        lineNumber: 145
    },
    {
        backendOwner: 'commerce-administrators',
        framework: 'Mantine',
        frontendOwner: 'commerce-administrators',
        filePath: 'pages/commerce-hub/src/components/component/impersonation-for-preview/VisitorSimulationModal.tsx',
        component: 'Modal',
        parent: 'VisitorSimulationModal',
        lineNumber: 49
    },
    {
        backendOwner: 'commerce-administrators',
        framework: 'Mantine',
        frontendOwner: 'commerce-administrators',
        filePath: 'pages/commerce-hub/src/components/component/ranking-visibility/OldRankingVisibilityModal.tsx',
        component: 'Modal',
        parent: 'OldRankingVisibilityModal',
        lineNumber: 134
    },
    {
        backendOwner: 'commerce-administrators',
        framework: 'Mantine',
        frontendOwner: 'commerce-administrators',
        filePath: 'pages/commerce-hub/src/components/component/ranking-visibility/RulePreviewRankingVisibilityModal.tsx',
        component: 'Modal',
        parent: 'RulePreviewRankingVisibilityModal',
        lineNumber: 138
    },
    {
        backendOwner: 'commerce-administrators',
        framework: 'Mantine',
        frontendOwner: 'commerce-administrators',
        filePath: 'pages/commerce-hub/src/components/component/rule-copying-modal/RuleCopyingModal.tsx',
        component: 'Modal',
        parent: 'RuleCopyingModal',
        lineNumber: 144
    },
    {
        backendOwner: 'commerce-administrators',
        framework: 'Mantine',
        frontendOwner: 'commerce-administrators',
        filePath: 'pages/commerce-hub/src/components/facets/building-blocks/display-names/EditDisplayNamesModal.tsx',
        component: 'Modal',
        parent: 'EditDisplayNamesModal',
        lineNumber: 57
    },
    {
        backendOwner: 'commerce-administrators',
        framework: 'Mantine',
        frontendOwner: 'commerce-administrators',
        filePath: 'pages/commerce-hub/src/components/facets/building-blocks/facet-field-configuration-form/PinValuesFormModal.tsx',
        component: 'Modal',
        parent: 'PinValuesFormModal',
        lineNumber: 74
    },
    {
        backendOwner: 'commerce-administrators',
        framework: 'Mantine',
        frontendOwner: 'commerce-administrators',
        filePath: 'pages/commerce-hub/src/components/facets/building-blocks/relevance-facets/RelevanceConfigModal.tsx',
        component: 'Modal',
        parent: 'RelevanceConfigModal',
        lineNumber: 42
    },
    {
        backendOwner: 'commerce-administrators',
        framework: 'Mantine',
        frontendOwner: 'commerce-administrators',
        filePath: 'pages/commerce-hub/src/components/facets/facet-manager/top-facet-engagements/TopFacetEngagements.tsx',
        component: 'Modal',
        parent: 'TopFacetEngagements',
        lineNumber: 89
    },
    {
        backendOwner: 'commerce-administrators',
        framework: 'Mantine',
        frontendOwner: 'commerce-administrators',
        filePath: 'pages/commerce-hub/src/components/listings/listing-config-editor-modal/ListingConfigEditorModal.tsx',
        component: 'Modal',
        parent: 'ListingConfigEditorModal',
        lineNumber: 123
    },
    {
        backendOwner: 'commerce-administrators',
        framework: 'Mantine',
        frontendOwner: 'commerce-administrators',
        filePath: 'pages/commerce-hub/src/components/listings/listing-details/facets-tab/AssociationModal.tsx',
        component: 'Modal',
        parent: 'AssociationModal',
        lineNumber: 38
    },
    {
        backendOwner: 'commerce-administrators',
        framework: 'Mantine',
        frontendOwner: 'commerce-administrators',
        filePath: 'pages/commerce-hub/src/components/recs/recs-details/configuration/EditSlotNameModal.tsx',
        component: 'Modal',
        parent: 'EditSlotNameModal',
        lineNumber: 31
    },
    {
        backendOwner: 'commerce-administrators',
        framework: 'Mantine',
        frontendOwner: 'commerce-administrators',
        filePath: 'pages/commerce-hub/src/components/recs/recs-details/configuration/EditSlotThresholdsModal.tsx',
        component: 'Modal',
        parent: 'EditSlotThresholdsModal',
        lineNumber: 29
    },
    {
        backendOwner: 'commerce-administrators',
        framework: 'Mantine',
        frontendOwner: 'commerce-administrators',
        filePath: 'pages/commerce-hub/src/pages/badges/BadgeEditorPage.tsx',
        component: 'Page',
        parent: 'BadgeEditorPage',
        lineNumber: 42
    },
    {
        backendOwner: 'commerce-administrators',
        framework: 'Mantine',
        frontendOwner: 'commerce-administrators',
        filePath: 'pages/commerce-hub/src/pages/badges/BadgeManagerPage.tsx',
        component: 'Page',
        parent: 'BadgeManagerPage',
        lineNumber: 26
    },
    {
        backendOwner: 'commerce-administrators',
        framework: 'Mantine',
        frontendOwner: 'commerce-administrators',
        filePath: 'pages/commerce-hub/src/pages/badges/BadgePlacementEditorPage.tsx',
        component: 'Page',
        parent: 'BadgePlacementEditorPage',
        lineNumber: 19
    },
    {
        backendOwner: 'commerce-administrators',
        framework: 'Mantine',
        frontendOwner: 'commerce-administrators',
        filePath: 'pages/commerce-hub/src/pages/facets/FacetFieldConfigurationEditorPage.tsx',
        component: 'Page',
        parent: 'FacetFieldConfigurationEditorPage',
        lineNumber: 18
    },
    {
        backendOwner: 'commerce-administrators',
        framework: 'Mantine',
        frontendOwner: 'commerce-administrators',
        filePath: 'pages/commerce-hub/src/pages/facets/FacetsManagerPage.tsx',
        component: 'Page',
        parent: 'FacetsManagerPage',
        lineNumber: 15
    },
    {
        backendOwner: 'commerce-administrators',
        framework: 'Mantine',
        frontendOwner: 'commerce-administrators',
        filePath: 'pages/commerce-hub/src/pages/listings/ListingDetailsPage.tsx',
        component: 'Page',
        parent: 'ListingDetailsPage',
        lineNumber: 14
    },
    {
        backendOwner: 'commerce-administrators',
        framework: 'Mantine',
        frontendOwner: 'commerce-administrators',
        filePath: 'pages/commerce-hub/src/pages/listings/ListingFacetsCollectionEditorPage.tsx',
        component: 'Page',
        parent: 'ListingFacetsCollectionEditorPage',
        lineNumber: 15
    },
    {
        backendOwner: 'commerce-administrators',
        framework: 'Mantine',
        frontendOwner: 'commerce-administrators',
        filePath: 'pages/commerce-hub/src/pages/listings/ListingManagerEditorPage.tsx',
        component: 'Page',
        parent: 'ListingManagerEditorPage',
        lineNumber: 16
    },
    {
        backendOwner: 'commerce-administrators',
        framework: 'Mantine',
        frontendOwner: 'commerce-administrators',
        filePath: 'pages/commerce-hub/src/pages/listings/ListingManagerPage.tsx',
        component: 'Page',
        parent: 'ListingManagerPage',
        lineNumber: 14
    },
    {
        backendOwner: 'commerce-administrators',
        framework: 'Mantine',
        frontendOwner: 'commerce-administrators',
        filePath: 'pages/commerce-hub/src/pages/overview/OverviewPage.tsx',
        component: 'Page',
        parent: 'OverviewPage',
        lineNumber: 79
    },
    {
        backendOwner: 'commerce-administrators',
        framework: 'Mantine',
        frontendOwner: 'commerce-administrators',
        filePath: 'pages/commerce-hub/src/pages/properties/PropertyEditorPage.tsx',
        component: 'Page',
        parent: 'PropertyEditorPage',
        lineNumber: 17
    },
    {
        backendOwner: 'commerce-administrators',
        framework: 'Mantine',
        frontendOwner: 'commerce-administrators',
        filePath: 'pages/commerce-hub/src/pages/recs/RecommendationDetailsPage.tsx',
        component: 'Page',
        parent: 'RecommendationDetailsPage',
        lineNumber: 14
    },
    {
        backendOwner: 'commerce-administrators',
        framework: 'Mantine',
        frontendOwner: 'commerce-administrators',
        filePath: 'pages/commerce-hub/src/pages/recs/RecommendationRuleEditorPage.tsx',
        component: 'Page',
        parent: 'RecommendationRuleEditorPage',
        lineNumber: 14
    },
    {
        backendOwner: 'commerce-administrators',
        framework: 'Mantine',
        frontendOwner: 'commerce-administrators',
        filePath: 'pages/commerce-hub/src/pages/recs/RecommendationStrategyEditorPage.tsx',
        component: 'Page',
        parent: 'RecommendationStrategyEditorPage',
        lineNumber: 17
    },
    {
        backendOwner: 'commerce-administrators',
        framework: 'Mantine',
        frontendOwner: 'commerce-administrators',
        filePath: 'pages/commerce-hub/src/pages/recs/RecommendationsManagerPage.tsx',
        component: 'Page',
        parent: 'RecommendationsManagerPage',
        lineNumber: 15
    },
    {
        backendOwner: 'commerce-administrators',
        framework: 'Mantine',
        frontendOwner: 'commerce-administrators',
        filePath: 'pages/commerce-hub/src/pages/recs/SlotEditorPage.tsx',
        component: 'Page',
        parent: 'SlotEditorPage',
        lineNumber: 17
    },
    {
        backendOwner: 'commerce-administrators',
        framework: 'Mantine',
        frontendOwner: 'commerce-administrators',
        filePath: 'pages/commerce-hub/src/pages/search/SearchDetailsPage.tsx',
        component: 'Page',
        parent: 'SearchDetailsPage',
        lineNumber: 14
    },
    {
        backendOwner: 'commerce-administrators',
        framework: 'Mantine',
        frontendOwner: 'commerce-administrators',
        filePath: 'pages/commerce-hub/src/pages/search/SearchFacetsCollectionEditorPage.tsx',
        component: 'Page',
        parent: 'FacetCollectionConfigurationPage',
        lineNumber: 15
    },
    {
        backendOwner: 'commerce-administrators',
        framework: 'Mantine',
        frontendOwner: 'commerce-administrators',
        filePath: 'pages/commerce-hub/src/pages/search/SearchManagerEditorPage.tsx',
        component: 'Page',
        parent: 'SearchManagerEditorPage',
        lineNumber: 16
    },
    {
        backendOwner: 'commerce-administrators',
        framework: 'Mantine',
        frontendOwner: 'commerce-administrators',
        filePath: 'pages/commerce-hub/src/pages/search/SearchManagerPage.tsx',
        component: 'Page',
        parent: 'SearchManagerPage',
        lineNumber: 15
    },
    {
        backendOwner: 'commerce-administrators',
        framework: 'Mantine',
        frontendOwner: 'commerce-administrators',
        filePath: 'pages/commerce-hub/src/pages/search/SynonymManagerEditorPage.tsx',
        component: 'Page',
        parent: 'SynonymManagerEditorPage',
        lineNumber: 14
    },
    {
        backendOwner: 'searchapi',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/conditions/src/pages/ConditionsCreationPage.tsx',
        component: 'Page',
        parent: 'ConditionsCreationPage',
        lineNumber: 12
    },
    {
        backendOwner: 'searchapi',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/conditions/src/pages/ConditionsEditCodePage.tsx',
        component: 'Page',
        parent: 'ConditionsEditCodePage',
        lineNumber: 14
    },
    {
        backendOwner: 'searchapi',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/conditions/src/pages/ConditionsEditPage.tsx',
        component: 'Page',
        parent: 'ConditionsEditPage',
        lineNumber: 23
    },
    {
        backendOwner: 'searchapi',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/conditions/src/pages/ConditionsPage.tsx',
        component: 'Page',
        parent: 'ConditionsPage',
        lineNumber: 11
    },
    {
        backendOwner: 'searchapi',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/conditions/src/pages/ConditionsViewPage.tsx',
        component: 'Page',
        parent: 'ConditionsViewPage',
        lineNumber: 19
    },
    {
        backendOwner: 'searchapi',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/content-browser/src/components/ContentBrowserSearchAsModal.tsx',
        component: 'Modal',
        parent: 'ContentBrowserSearchAsModal',
        lineNumber: 83
    },
    {
        backendOwner: 'searchapi',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/content-browser/src/components/DebugModal.tsx',
        component: 'Modal',
        parent: 'DebugModalWrapper',
        lineNumber: 57
    },
    {
        backendOwner: 'searchapi',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/content-browser/src/components/KeyValuesPairModal.tsx',
        component: 'Modal',
        parent: 'KeyValuesPairModal',
        lineNumber: 49
    },
    {
        backendOwner: 'searchapi',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/content-browser/src/components/PreferencesModal.tsx',
        component: 'Modal',
        parent: 'PreferencesModal',
        lineNumber: 68
    },
    {
        backendOwner: 'searchapi',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/content-browser/src/components/PropertiesModal.tsx',
        component: 'Modal',
        parent: 'PropertiesModalContent',
        lineNumber: 85
    },
    {
        backendOwner: 'searchapi',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/content-browser/src/components/ShareQueryModal.tsx',
        component: 'Modal',
        parent: 'ShareQueryModal',
        lineNumber: 18
    },
    {
        backendOwner: 'searchapi',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/content-browser/src/pages/ContentBrowserPage.tsx',
        component: 'Page',
        parent: 'ContentBrowserPage',
        lineNumber: 103
    },
    {
        backendOwner: 'knowledge-hub',
        framework: 'Mantine',
        frontendOwner: 'knowledge-hub',
        filePath: 'pages/conversation-inspector/src/pages/ConversationDetailPage.tsx',
        component: 'Page',
        parent: 'ConversationDetailPage',
        lineNumber: 46
    },
    {
        backendOwner: 'knowledge-hub',
        framework: 'Mantine',
        frontendOwner: 'knowledge-hub',
        filePath: 'pages/conversation-inspector/src/pages/ConversationInspectorLandingPage.tsx',
        component: 'Page',
        parent: 'ConversationInspectorLandingPage',
        lineNumber: 12
    },
    {
        backendOwner: 'knowledge-hub',
        framework: 'Mantine',
        frontendOwner: 'knowledge-hub',
        filePath: 'pages/conversation-inspector/src/pages/PassagesPage.tsx',
        component: 'Page',
        parent: 'PassagesPage',
        lineNumber: 49
    },
    {
        backendOwner: 'ctinfra',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/crawling-module/src/pages/CrawlingModulesListPage.tsx',
        component: 'Page',
        parent: 'CrawlingModulesListPage',
        lineNumber: 46
    },
    {
        backendOwner: 'knowledge-hub',
        framework: 'Mantine',
        frontendOwner: 'knowledge-hub',
        filePath: 'pages/crga-dashboard/src/components/ReportSectionModal.tsx',
        component: 'Modal',
        parent: 'ReportSectionModal',
        lineNumber: 24
    },
    {
        backendOwner: 'knowledge-hub',
        framework: 'Mantine',
        frontendOwner: 'knowledge-hub',
        filePath: 'pages/crga-dashboard/src/pages/cited-items/CitedItemsPage.tsx',
        component: 'Page',
        parent: 'CitedItemsPage',
        lineNumber: 24
    },
    {
        backendOwner: 'knowledge-hub',
        framework: 'Mantine',
        frontendOwner: 'knowledge-hub',
        filePath: 'pages/crga-dashboard/src/pages/feedback/FeedbackPage.tsx',
        component: 'Page',
        parent: 'FeedbackPage',
        lineNumber: 23
    },
    {
        backendOwner: 'knowledge-hub',
        framework: 'Mantine',
        frontendOwner: 'knowledge-hub',
        filePath: 'pages/crga-dashboard/src/pages/queries-without-generated-answers/QueriesWithoutGeneratedAnswersPage.tsx',
        component: 'Page',
        parent: 'QueriesWithoutGeneratedAnswersPage',
        lineNumber: 23
    },
    {
        backendOwner: 'knowledge-hub',
        framework: 'Mantine',
        frontendOwner: 'knowledge-hub',
        filePath: 'pages/crga-dashboard/src/pages/search-hub-reports/SearchHubReportsPage.tsx',
        component: 'Page',
        parent: 'SearchHubReportsPage',
        lineNumber: 31
    },
    {
        backendOwner: 'knowledge-hub',
        framework: 'Mantine',
        frontendOwner: 'knowledge-hub',
        filePath: 'pages/crga-dashboard/src/pages/search-hubs-overview/SearchHubsOverview.tsx',
        component: 'Page',
        parent: 'SearchHubsOverview',
        lineNumber: 23
    },
    {
        backendOwner: 'dataplatformfoundation',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/data-health/src/components/DataHealthPage.tsx',
        component: 'Page',
        parent: 'DataHealthPage',
        lineNumber: 14
    },
    {
        backendOwner: 'dataplatformfoundation',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/data-health/src/components/tab/DataHealthLatestEventsTab.tsx',
        component: 'Modal',
        parent: 'DataHealthLatestEventsTab',
        lineNumber: 258
    },
    {
        backendOwner: 'dataplatformfoundation',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/data-health/src/components/tab/event-problems/EventProblemsCollapsibleRow.tsx',
        component: 'Modal',
        parent: 'EventProblemsCollapsibleRow',
        lineNumber: 82
    },
    {
        backendOwner: 'dataplatformfoundation',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/data-health/src/components/tab/overview/ShowGroupDetailsActionModal.tsx',
        component: 'Modal',
        parent: 'ShowGroupDetailsActionModal',
        lineNumber: 142
    },
    {
        backendOwner: 'dataplatformfoundation',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/dimensions/src/pages/AddDimensionPage.tsx',
        component: 'Page',
        parent: 'AddDimensionPage',
        lineNumber: 38
    },
    {
        backendOwner: 'dataplatformfoundation',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/dimensions/src/pages/EditDimensionPage.tsx',
        component: 'Page',
        parent: 'EditDimensionPage',
        lineNumber: 9
    },
    {
        backendOwner: 'dataplatformfoundation',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/dimensions/src/pages/ListDimensionsPage.tsx',
        component: 'Page',
        parent: 'ListDimensionsPage',
        lineNumber: 44
    },
    {
        backendOwner: 'index-indexing',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/extensions/src/components/modals/BrowseExtensionVersionsModal.tsx',
        component: 'Modal',
        parent: 'BrowseExtensionVersionsModal',
        lineNumber: 76
    },
    {
        backendOwner: 'index-indexing',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/extensions/src/components/modals/DisableExtensionModal.tsx',
        component: 'Modal',
        parent: 'DisableExtensionModal',
        lineNumber: 75
    },
    {
        backendOwner: 'index-indexing',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/extensions/src/components/modals/ExtensionAdditionalInfoModal.tsx',
        component: 'Modal.Root',
        parent: 'ExtensionAdditionalInfoModal',
        lineNumber: 168
    },
    {
        backendOwner: 'searchapi',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/extensions/src/components/modals/edit/EditExtensionModal.tsx',
        component: 'Modal.Root',
        parent: 'EditExtensionModal',
        lineNumber: 236
    },
    {
        backendOwner: 'index-indexing',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/extensions/src/pages/ExtensionsPage.tsx',
        component: 'Page',
        parent: 'ExtensionsPage',
        lineNumber: 16
    },
    {
        backendOwner: 'platform-resource-insight',
        framework: 'Mantine',
        frontendOwner: 'platform-resource-insight',
        filePath: 'pages/home/src/pages/HomePage.tsx',
        component: 'Page',
        parent: 'HomePage',
        lineNumber: 8
    },
    {
        backendOwner: 'platform-solution-experience',
        framework: 'PlasmaReact',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/home/src/pages/TrialDashboardPage.tsx',
        component: 'Page',
        parent: 'TrialDashboardPage',
        lineNumber: 10
    },
    {
        backendOwner: 'knowledge-core',
        framework: 'Mantine',
        frontendOwner: 'knowledge-hub',
        filePath: 'pages/in-product-experience/src/modals/ChooseIPXTypeModal.tsx',
        component: 'Modal',
        parent: 'ChooseIPXTypeModal',
        lineNumber: 23
    },
    {
        backendOwner: 'knowledge-core',
        framework: 'Mantine',
        frontendOwner: 'knowledge-hub',
        filePath: 'pages/in-product-experience/src/modals/CreateIPXv2Modal.tsx',
        component: 'Modal',
        parent: 'CreateIPXv2Modal',
        lineNumber: 126
    },
    {
        backendOwner: 'knowledge-core',
        framework: 'Mantine',
        frontendOwner: 'knowledge-hub',
        filePath: 'pages/in-product-experience/src/modals/DuplicateIPXModal.tsx',
        component: 'Modal',
        parent: 'DuplicateIPXModal',
        lineNumber: 106
    },
    {
        backendOwner: 'knowledge-core',
        framework: 'Mantine',
        frontendOwner: 'knowledge-hub',
        filePath: 'pages/in-product-experience/src/pages/CreateAndEditClassicIPXPage.tsx',
        component: 'Page',
        parent: 'CreateAndEditClassicIPXPage',
        lineNumber: 22
    },
    {
        backendOwner: 'knowledge-core',
        framework: 'Mantine',
        frontendOwner: 'knowledge-hub',
        filePath: 'pages/in-product-experience/src/pages/IPXListingPage.tsx',
        component: 'Page',
        parent: 'IPXListingPage',
        lineNumber: 17
    },
    {
        backendOwner: 'index-indexing',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/index/src/components/index/automation-freezes-info/AutomationFreezesInfo.tsx',
        component: 'Modal',
        parent: 'AutomationFreezesInfo',
        lineNumber: 78
    },
    {
        backendOwner: 'index-indexing',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/index/src/components/index/modals/AddIndexModal.tsx',
        component: 'Modal',
        parent: 'AddIndexModal',
        lineNumber: 44
    },
    {
        backendOwner: 'index-indexing',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/index/src/components/index/modals/ResizeDiskSpaceModal.tsx',
        component: 'Modal',
        parent: 'ResizeDiskSpaceModal',
        lineNumber: 41
    },
    {
        backendOwner: 'index-indexing',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/index/src/components/index/modals/RestoreBackupModal.tsx',
        component: 'Modal',
        parent: 'RestoreBackupModal',
        lineNumber: 97
    },
    {
        backendOwner: 'index-indexing',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/index/src/components/index/modals/copy/CopyIndexModal.tsx',
        component: 'Modal',
        parent: 'CopyIndexModal',
        lineNumber: 20
    },
    {
        backendOwner: 'index-indexing',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/index/src/components/index/modals/edit/EditJsonModal.tsx',
        component: 'Modal',
        parent: 'EditJsonModal',
        lineNumber: 19
    },
    {
        backendOwner: 'index-indexing',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/index/src/pages/ClusterPage.tsx',
        component: 'Page',
        parent: 'ClusterPage',
        lineNumber: 10
    },
    {
        backendOwner: 'index-indexing',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/index/src/pages/IndexDetailsPage.tsx',
        component: 'Page',
        parent: 'IndexDetailsPage',
        lineNumber: 51
    },
    {
        backendOwner: 'index-indexing',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/index/src/pages/IndexPage.tsx',
        component: 'Page',
        parent: 'IndexPage',
        lineNumber: 17
    },
    {
        backendOwner: 'platform-identity-and-entitlements',
        framework: 'Mantine',
        frontendOwner: 'platform-identity-and-entitlements',
        filePath: 'pages/license-and-usage/src/pages/EntitlementDetailsPage.tsx',
        component: 'Page',
        parent: 'EntitlementDetailsPage',
        lineNumber: 125
    },
    {
        backendOwner: 'platform-identity-and-entitlements',
        framework: 'Mantine',
        frontendOwner: 'platform-identity-and-entitlements',
        filePath: 'pages/license-and-usage/src/pages/LicenseAndUsagePage.tsx',
        component: 'Page',
        parent: 'LicenseAndUsagePage',
        lineNumber: 45
    },
    {
        backendOwner: 'platform-identity-and-entitlements',
        framework: 'Mantine',
        frontendOwner: 'platform-identity-and-entitlements',
        filePath: 'pages/license-and-usage/src/pages/QuotaDetailsPage.tsx',
        component: 'Page',
        parent: 'QuotaDetailsPage',
        lineNumber: 120
    },
    {
        backendOwner: 'knowledge-hub',
        framework: 'Mantine',
        frontendOwner: 'knowledge-hub',
        filePath: 'pages/mcp-configuration/src/components/edit/tool-forms/AddToolAction.tsx',
        component: 'Modal',
        parent: 'AddToolActionModal',
        lineNumber: 49
    },
    {
        backendOwner: 'knowledge-hub',
        framework: 'Mantine',
        frontendOwner: 'knowledge-hub',
        filePath: 'pages/mcp-configuration/src/components/edit/tool-forms/EditToolAction.tsx',
        component: 'Modal',
        parent: 'EditToolActionModal',
        lineNumber: 57
    },
    {
        backendOwner: 'knowledge-hub',
        framework: 'Mantine',
        frontendOwner: 'knowledge-hub',
        filePath: 'pages/mcp-configuration/src/pages/MCPConfigurationsAddPage.tsx',
        component: 'Page',
        parent: 'MCPConfigurationsAddPage',
        lineNumber: 10
    },
    {
        backendOwner: 'knowledge-hub',
        framework: 'Mantine',
        frontendOwner: 'knowledge-hub',
        filePath: 'pages/mcp-configuration/src/pages/MCPConfigurationsEditPage.tsx',
        component: 'Page',
        parent: 'MCPConfigurationsEditPage',
        lineNumber: 10
    },
    {
        backendOwner: 'knowledge-hub',
        framework: 'Mantine',
        frontendOwner: 'knowledge-hub',
        filePath: 'pages/mcp-configuration/src/pages/MCPConfigurationsListPage.tsx',
        component: 'Page',
        parent: 'MCPConfigurationsListPage',
        lineNumber: 9
    },
    {
        backendOwner: 'knowledge-hub',
        framework: 'Mantine',
        frontendOwner: 'knowledge-hub',
        filePath: 'pages/mcp-configuration/src/pages/MCPConfigurationsViewPage.tsx',
        component: 'Page',
        parent: 'MCPConfigurationsViewPage',
        lineNumber: 10
    },
    {
        backendOwner: 'ml-platform-building',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/model/src/components/flow-modal-wizard/ModalWizardLayout.tsx',
        component: 'ModalWizard',
        parent: 'ModalWizardContent',
        lineNumber: 183
    },
    {
        backendOwner: 'ml-core-ai-dev',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/model/src/components/flow-steps/model-steps/ARTFlow.tsx',
        component: 'ModalWizardLayout',
        parent: 'ARTFlow',
        lineNumber: 86
    },
    {
        backendOwner: 'ml-knowai',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/model/src/components/flow-steps/model-steps/CCFlow.tsx',
        component: 'ModalWizardLayout',
        parent: 'CCFlow',
        lineNumber: 116
    },
    {
        backendOwner: 'ml-knowai',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/model/src/components/flow-steps/model-steps/CPRFlow.tsx',
        component: 'ModalWizardLayout',
        parent: 'CPRFlow',
        lineNumber: 82
    },
    {
        backendOwner: 'ml-core-ai-dev',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/model/src/components/flow-steps/model-steps/CRFlow.tsx',
        component: 'ModalWizardLayout',
        parent: 'CRFlow',
        lineNumber: 94
    },
    {
        backendOwner: 'ml-core-ai-dev',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/model/src/components/flow-steps/model-steps/DNEFlow.tsx',
        component: 'ModalWizardLayout',
        parent: 'DNEFlow',
        lineNumber: 95
    },
    {
        backendOwner: 'ml-commerce-ai',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/model/src/components/flow-steps/model-steps/IAPRFlow.tsx',
        component: 'ModalWizardLayout',
        parent: 'IAPRFlowModal',
        lineNumber: 83
    },
    {
        backendOwner: 'ml-commerce-ai',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/model/src/components/flow-steps/model-steps/PQSFlow.tsx',
        component: 'ModalWizardLayout',
        parent: 'PQSFlowModal',
        lineNumber: 116
    },
    {
        backendOwner: 'ml-commerce-ai',
        framework: 'Mantine',
        frontendOwner: 'cartel',
        filePath: 'pages/model/src/components/flow-steps/model-steps/PRFlow.tsx',
        component: 'ModalWizardLayout',
        parent: 'PRFlowModal',
        lineNumber: 85
    },
    {
        backendOwner: 'ml-core-ai-dev',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/model/src/components/flow-steps/model-steps/QSFlow.tsx',
        component: 'ModalWizardLayout',
        parent: 'QSFlow',
        lineNumber: 85
    },
    {
        backendOwner: 'ml-knowai',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/model/src/components/flow-steps/model-steps/RGAFlow.tsx',
        component: 'ModalWizardLayout',
        parent: 'RGAFlow',
        lineNumber: 99
    },
    {
        backendOwner: 'ml-knowai',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/model/src/components/flow-steps/model-steps/SEFlow.tsx',
        component: 'ModalWizardLayout',
        parent: 'SEFlow',
        lineNumber: 82
    },
    {
        backendOwner: 'ml-knowai',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/model/src/components/flow-steps/model-steps/SSFlow.tsx',
        component: 'ModalWizardLayout',
        parent: 'SSFlow',
        lineNumber: 96
    },
    {
        backendOwner: 'ml-platform-building',
        framework: [
            'Mantine',
            'PlasmaReact'
        ],
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/model/src/components/model-edition/ModelEdition.tsx',
        component: 'Page',
        parent: 'ModelEdition',
        lineNumber: 127
    },
    {
        backendOwner: 'ml-core-ai-dev',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/model/src/components/model-edition/model-edition-configurations/ARTEditConfiguration.tsx',
        component: 'OwnerConfiguration',
        parent: 'ARTEditConfiguration',
        lineNumber: 18
    },
    {
        backendOwner: 'ml-core-ai-dev',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/model/src/components/model-edition/model-edition-configurations/ARTViewConfiguration.tsx',
        component: 'OwnerConfiguration',
        parent: 'ARTViewConfiguration',
        lineNumber: 22
    },
    {
        backendOwner: 'ml-knowai',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/model/src/components/model-edition/model-edition-configurations/CCEditConfiguration.tsx',
        component: 'OwnerConfiguration',
        parent: 'CCView',
        lineNumber: 44
    },
    {
        backendOwner: 'ml-knowai',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/model/src/components/model-edition/model-edition-configurations/CCViewConfiguration.tsx',
        component: 'OwnerConfiguration',
        parent: 'CCViewConfiguration',
        lineNumber: 15
    },
    {
        backendOwner: 'ml-knowai',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/model/src/components/model-edition/model-edition-configurations/CPREditConfiguration.tsx',
        component: 'OwnerConfiguration',
        parent: 'CPREditConfiguration',
        lineNumber: 25
    },
    {
        backendOwner: 'ml-knowai',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/model/src/components/model-edition/model-edition-configurations/CPRViewConfiguration.tsx',
        component: 'OwnerConfiguration',
        parent: 'CPRViewConfiguration',
        lineNumber: 14
    },
    {
        backendOwner: 'ml-core-ai-dev',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/model/src/components/model-edition/model-edition-configurations/CREditConfiguration.tsx',
        component: 'OwnerConfiguration',
        parent: 'CREditConfiguration',
        lineNumber: 12
    },
    {
        backendOwner: 'ml-core-ai-dev',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/model/src/components/model-edition/model-edition-configurations/CRViewConfiguration.tsx',
        component: 'OwnerConfiguration',
        parent: 'CRViewConfiguration',
        lineNumber: 18
    },
    {
        backendOwner: 'ml-core-ai-dev',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/model/src/components/model-edition/model-edition-configurations/DNEEditConfiguration.tsx',
        component: 'OwnerConfiguration',
        parent: 'DNEEditConfiguration',
        lineNumber: 12
    },
    {
        backendOwner: 'ml-core-ai-dev',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/model/src/components/model-edition/model-edition-configurations/DNEViewConfiguration.tsx',
        component: 'OwnerConfiguration',
        parent: 'DNEViewConfiguration',
        lineNumber: 19
    },
    {
        backendOwner: 'ml-commerce-ai',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/model/src/components/model-edition/model-edition-configurations/DeprecatedPREditConfiguration.tsx',
        component: 'OwnerConfiguration',
        parent: 'DeprecatedPREditConfiguration',
        lineNumber: 22
    },
    {
        backendOwner: 'ml-commerce-ai',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/model/src/components/model-edition/model-edition-configurations/DeprecatedPRViewConfiguration.tsx',
        component: 'OwnerConfiguration',
        parent: 'DeprecatedPRViewConfiguration',
        lineNumber: 77
    },
    {
        backendOwner: 'ml-commerce-ai',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/model/src/components/model-edition/model-edition-configurations/IAPREditConfiguration.tsx',
        component: 'OwnerConfiguration',
        parent: 'IAPREditConfiguration',
        lineNumber: 12
    },
    {
        backendOwner: 'ml-commerce-ai',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/model/src/components/model-edition/model-edition-configurations/IAPRViewConfiguration.tsx',
        component: 'OwnerConfiguration',
        parent: 'IAPRViewConfiguration',
        lineNumber: 9
    },
    {
        backendOwner: 'ml-commerce-ai',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/model/src/components/model-edition/model-edition-configurations/PQSEditConfiguration.tsx',
        component: 'OwnerConfiguration',
        parent: 'PQSEditConfiguration',
        lineNumber: 14
    },
    {
        backendOwner: 'ml-commerce-ai',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/model/src/components/model-edition/model-edition-configurations/PQSViewConfiguration.tsx',
        component: 'OwnerConfiguration',
        parent: 'PQSViewConfiguration',
        lineNumber: 23
    },
    {
        backendOwner: 'ml-commerce-ai',
        framework: 'Mantine',
        frontendOwner: 'cartel',
        filePath: 'pages/model/src/components/model-edition/model-edition-configurations/PREditConfiguration.tsx',
        component: 'OwnerConfiguration',
        parent: 'PREditConfiguration',
        lineNumber: 30
    },
    {
        backendOwner: 'ml-commerce-ai',
        framework: 'Mantine',
        frontendOwner: 'cartel',
        filePath: 'pages/model/src/components/model-edition/model-edition-configurations/PRViewConfiguration.tsx',
        component: 'OwnerConfiguration',
        parent: 'PRViewConfiguration',
        lineNumber: 15
    },
    {
        backendOwner: 'ml-core-ai-dev',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/model/src/components/model-edition/model-edition-configurations/QSEditConfiguration.tsx',
        component: 'OwnerConfiguration',
        parent: 'QSEditConfiguration',
        lineNumber: 12
    },
    {
        backendOwner: 'ml-core-ai-dev',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/model/src/components/model-edition/model-edition-configurations/QSViewConfiguration.tsx',
        component: 'OwnerConfiguration',
        parent: 'QSViewConfiguration',
        lineNumber: 23
    },
    {
        backendOwner: 'ml-knowai',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/model/src/components/model-edition/model-edition-configurations/RGAEditConfiguration.tsx',
        component: 'OwnerConfiguration',
        parent: 'RGAEditConfiguration',
        lineNumber: 27
    },
    {
        backendOwner: 'ml-knowai',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/model/src/components/model-edition/model-edition-configurations/RGAViewConfiguration.tsx',
        component: 'OwnerConfiguration',
        parent: 'RGAViewConfiguration',
        lineNumber: 15
    },
    {
        backendOwner: 'ml-knowai',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/model/src/components/model-edition/model-edition-configurations/SEEditConfiguration.tsx',
        component: 'OwnerConfiguration',
        parent: 'SEEditConfiguration',
        lineNumber: 25
    },
    {
        backendOwner: 'ml-knowai',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/model/src/components/model-edition/model-edition-configurations/SEViewconfiguration.tsx',
        component: 'OwnerConfiguration',
        parent: 'SEViewConfiguration',
        lineNumber: 9
    },
    {
        backendOwner: 'ml-knowai',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/model/src/components/model-edition/model-edition-configurations/SSEditConfiguration.tsx',
        component: 'OwnerConfiguration',
        parent: 'SSEditConfiguration',
        lineNumber: 31
    },
    {
        backendOwner: 'ml-knowai',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/model/src/components/model-edition/model-edition-configurations/SSViewConfiguration.tsx',
        component: 'OwnerConfiguration',
        parent: 'SSViewConfiguration',
        lineNumber: 15
    },
    {
        backendOwner: 'ml-platform-building',
        framework: [
            'Mantine',
            'PlasmaReact'
        ],
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/model/src/components/model-json-modal/ModelJsonModal.tsx',
        component: 'Modal',
        parent: 'ModelJsonModal',
        lineNumber: 114
    },
    {
        backendOwner: 'ml-platform-building',
        framework: [
            'Mantine',
            'PlasmaReact'
        ],
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/model/src/components/models-page/ModelsPage.tsx',
        component: 'Modal',
        parent: 'ModelPageContent',
        lineNumber: 68
    },
    {
        backendOwner: 'ml-platform-building',
        framework: [
            'Mantine',
            'PlasmaReact'
        ],
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/model/src/components/models-page/ModelsPage.tsx',
        component: 'Page',
        parent: 'ModelsPage',
        lineNumber: 95
    },
    {
        backendOwner: 'ml-commerce-ai',
        framework: 'Mantine',
        frontendOwner: 'cartel',
        filePath: 'pages/model/src/dynamic-flow/creation/CreationFlowLayout.tsx',
        component: 'ModalWizardLayout',
        parent: 'CreationFlowLayoutModal',
        lineNumber: 78
    },
    {
        backendOwner: 'ml-commerce-ai',
        framework: 'Mantine',
        frontendOwner: 'cartel',
        filePath: 'pages/model/src/dynamic-flow/information/InformationFlowLayout.tsx',
        component: 'OwnerConfiguration',
        parent: 'InformationFlowLayout',
        lineNumber: 15
    },
    {
        backendOwner: 'ml-commerce-ai',
        framework: 'Mantine',
        frontendOwner: 'cartel',
        filePath: 'pages/model/src/dynamic-flow/management/ManagementFlowLayout.tsx',
        component: 'OwnerConfiguration',
        parent: 'ManagementFlowLayout',
        lineNumber: 40
    },
    {
        backendOwner: 'dataplatformfoundation',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/named-filters/src/pages/AddNamedFilterPage.tsx',
        component: 'Page',
        parent: 'AddNamedFilterPage',
        lineNumber: 10
    },
    {
        backendOwner: 'dataplatformfoundation',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/named-filters/src/pages/EditNamedFilterPage.tsx',
        component: 'Page',
        parent: 'EditNamedFilterPage',
        lineNumber: 8
    },
    {
        backendOwner: 'dataplatformfoundation',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/named-filters/src/pages/ListNamedFiltersPage.tsx',
        component: 'Page',
        parent: 'ListNamedFiltersPage',
        lineNumber: 44
    },
    {
        backendOwner: 'searchapi',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/organization-settings/src/pages/encryption-keys/AddEncryptionKeyPage.tsx',
        component: 'Page',
        parent: 'AddEncryptionKeyPage',
        lineNumber: 9
    },
    {
        backendOwner: 'dataplatformfoundation',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/permission-filters/src/pages/AddPermissionFilterPage.tsx',
        component: 'Page',
        parent: 'AddPermissionFilterPage',
        lineNumber: 11
    },
    {
        backendOwner: 'dataplatformfoundation',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/permission-filters/src/pages/EditPermissionFilterPage.tsx',
        component: 'Page',
        parent: 'EditPermissionFilterPage',
        lineNumber: 9
    },
    {
        backendOwner: 'dataplatformfoundation',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/permission-filters/src/pages/ListPermissionFiltersPage.tsx',
        component: 'Page',
        parent: 'ListPermissionFiltersPage',
        lineNumber: 45
    },
    {
        backendOwner: 'platform-identity-and-entitlements',
        framework: 'Mantine',
        frontendOwner: 'platform-identity-and-entitlements',
        filePath: 'pages/privileges/src/pages/api-keys/api-keys-creation/APIKeysCreationPage.tsx',
        component: 'Page',
        parent: 'APIKeysCreationPage',
        lineNumber: 30
    },
    {
        backendOwner: 'platform-identity-and-entitlements',
        framework: 'Mantine',
        frontendOwner: 'platform-identity-and-entitlements',
        filePath: 'pages/privileges/src/pages/api-keys/api-keys-details/ApiKeysEditPage.tsx',
        component: 'Page',
        parent: 'ApiKeysEditPage',
        lineNumber: 18
    },
    {
        backendOwner: 'platform-identity-and-entitlements',
        framework: 'Mantine',
        frontendOwner: 'platform-identity-and-entitlements',
        filePath: 'pages/privileges/src/pages/api-keys/api-keys-details/ApiKeysViewPage.tsx',
        component: 'Page',
        parent: 'ApiKeysViewPage',
        lineNumber: 14
    },
    {
        backendOwner: 'platform-identity-and-entitlements',
        framework: 'Mantine',
        frontendOwner: 'platform-identity-and-entitlements',
        filePath: 'pages/privileges/src/pages/api-keys/api-keys-list/APIKeysListingPage.tsx',
        component: 'Page',
        parent: 'APIKeysListingPage',
        lineNumber: 13
    },
    {
        backendOwner: 'platform-identity-and-entitlements',
        framework: 'Mantine',
        frontendOwner: 'platform-identity-and-entitlements',
        filePath: 'pages/privileges/src/pages/global-groups/GlobalGroupsEditPage.tsx',
        component: 'Page',
        parent: 'GlobalGroupsEditPage',
        lineNumber: 77
    },
    {
        backendOwner: 'platform-identity-and-entitlements',
        framework: 'Mantine',
        frontendOwner: 'platform-identity-and-entitlements',
        filePath: 'pages/privileges/src/pages/global-groups/GlobalGroupsListingPage.tsx',
        component: 'Page',
        parent: 'GlobalGroupsListingPage',
        lineNumber: 44
    },
    {
        backendOwner: 'platform-identity-and-entitlements',
        framework: 'Mantine',
        frontendOwner: 'platform-identity-and-entitlements',
        filePath: 'pages/privileges/src/pages/global-groups/GlobalGroupsViewPage.tsx',
        component: 'Page',
        parent: 'GlobalGroupsViewPage',
        lineNumber: 65
    },
    {
        backendOwner: 'platform-identity-and-entitlements',
        framework: 'Mantine',
        frontendOwner: 'platform-identity-and-entitlements',
        filePath: 'pages/privileges/src/pages/global-groups/global-groups-creation/GlobalGroupsCreationPage.tsx',
        component: 'Page',
        parent: 'GlobalGroupsCreationPage',
        lineNumber: 13
    },
    {
        backendOwner: 'platform-resource-insight',
        framework: 'Mantine',
        frontendOwner: 'platform-resource-insight',
        filePath: 'pages/project/src/pages/ProjectCreationPage.tsx',
        component: 'Page',
        parent: 'ProjectCreationPage',
        lineNumber: 9
    },
    {
        backendOwner: 'platform-resource-insight',
        framework: 'Mantine',
        frontendOwner: 'platform-resource-insight',
        filePath: 'pages/project/src/pages/ProjectEditPage.tsx',
        component: 'Page',
        parent: 'ProjectEditPage',
        lineNumber: 14
    },
    {
        backendOwner: 'platform-resource-insight',
        framework: 'Mantine',
        frontendOwner: 'platform-resource-insight',
        filePath: 'pages/project/src/pages/ProjectViewPage.tsx',
        component: 'Page',
        parent: 'ProjectViewPage',
        lineNumber: 9
    },
    {
        backendOwner: 'platform-resource-insight',
        framework: 'Mantine',
        frontendOwner: 'platform-resource-insight',
        filePath: 'pages/project/src/pages/ProjectsListPage.tsx',
        component: 'Page',
        parent: 'ProjectsListPage',
        lineNumber: 31
    },
    {
        backendOwner: 'dataplatformfoundation',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/properties-manager/src/pages/CreatePropertyPage.tsx',
        component: 'Page',
        parent: 'CreatePropertyPage',
        lineNumber: 9
    },
    {
        backendOwner: 'dataplatformfoundation',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/properties-manager/src/pages/EditPropertyPage.tsx',
        component: 'Page',
        parent: 'EditPropertyPage',
        lineNumber: 16
    },
    {
        backendOwner: 'dataplatformfoundation',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/properties-manager/src/pages/ManagePropertiesPage.tsx',
        component: 'Page',
        parent: 'ManagePropertiesPage',
        lineNumber: 53
    },
    {
        backendOwner: 'searchapi',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/query-pipelines/src/components/groups/modals/DeleteGroupConfirmationModal.tsx',
        component: 'Modal',
        parent: 'DeleteGroupConfirmationModal',
        lineNumber: 70
    },
    {
        backendOwner: 'ml-platform-building',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/query-pipelines/src/components/ml-associations/edit/EditAssociationPage.tsx',
        component: 'Page',
        parent: 'EditAssociationPage',
        lineNumber: 39
    },
    {
        backendOwner: 'searchapi',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/query-pipelines/src/components/result-ranking-table/modals/add-result-ranking-modal/AddResultRankingModal.tsx',
        component: 'Modal',
        parent: 'AddResultRankingModal',
        lineNumber: 69
    },
    {
        backendOwner: 'searchapi',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/query-pipelines/src/components/result-ranking-table/modals/association-modal/AssociationModal.tsx',
        component: 'Modal',
        parent: 'AssociationModal',
        lineNumber: 103
    },
    {
        backendOwner: 'searchapi',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/query-pipelines/src/components/result-ranking-table/modals/copy-to-modal/CopyRulesModal.tsx',
        component: 'Modal',
        parent: 'CopyRulesModal',
        lineNumber: 58
    },
    {
        backendOwner: 'searchapi',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/query-pipelines/src/pages/AddRankingWeightPage.tsx',
        component: 'Page',
        parent: 'AddRankingWeightPage',
        lineNumber: 13
    },
    {
        backendOwner: 'searchapi',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/query-pipelines/src/pages/AddStopWordsPage.tsx',
        component: 'Page',
        parent: 'AddStopWordsPage',
        lineNumber: 17
    },
    {
        backendOwner: 'searchapi',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/query-pipelines/src/pages/EditRankingWeightPage.tsx',
        component: 'Page',
        parent: 'EditRankingWeightPage',
        lineNumber: 25
    },
    {
        backendOwner: 'searchapi',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/query-pipelines/src/pages/EditStopWordsPage.tsx',
        component: 'Page',
        parent: 'EditStopWordsPage',
        lineNumber: 40
    },
    {
        backendOwner: 'dataplatformfoundation',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/raw-data/src/components/data-exports/export-schedules/ScheduleModal.tsx',
        component: 'Modal',
        parent: 'ScheduleModal',
        lineNumber: 62
    },
    {
        backendOwner: 'dataplatformfoundation',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/raw-data/src/components/data-exports/export-schedules/ViewExportsModal.tsx',
        component: 'Modal',
        parent: 'ViewExportsModal',
        lineNumber: 14
    },
    {
        backendOwner: 'dataplatformfoundation',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/raw-data/src/components/data-exports/past-exports/create-export/CreateExportModal.tsx',
        component: 'Modal',
        parent: 'CreateExportModal',
        lineNumber: 42
    },
    {
        backendOwner: 'dataplatformfoundation',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/raw-data/src/components/data-exports/past-exports/recreate-export/RecreateDefaultExportModal.tsx',
        component: 'Modal',
        parent: 'RecreateDefaultExportModal',
        lineNumber: 44
    },
    {
        backendOwner: 'dataplatformfoundation',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/raw-data/src/components/data-exports/past-exports/recreate-export/RecreateVisitExportModal.tsx',
        component: 'Modal',
        parent: 'RecreateVisitExportModal',
        lineNumber: 124
    },
    {
        backendOwner: 'dataplatformfoundation',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/raw-data/src/components/snowflake/data-share/DataShareModal.tsx',
        component: 'Modal',
        parent: 'DataShareModal',
        lineNumber: 69
    },
    {
        backendOwner: 'dataplatformfoundation',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/raw-data/src/components/snowflake/reader-account/snowflake-users/ActivateUserModal.tsx',
        component: 'Modal',
        parent: 'ActivateUserModal',
        lineNumber: 99
    },
    {
        backendOwner: 'dataplatformfoundation',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/raw-data/src/pages/RawDataPage.tsx',
        component: 'Page',
        parent: 'RawDataPage',
        lineNumber: 18
    },
    {
        backendOwner: 'searchapi',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/relevance-inspector/src/components/relevance-inspector/RelevanceInspectorPage.tsx',
        component: 'Page',
        parent: 'RelevanceInspectorPage',
        lineNumber: 11
    },
    {
        backendOwner: 'knowledge-core',
        framework: 'Mantine',
        frontendOwner: 'knowledge-hub',
        filePath: 'pages/search-page/src/components/modals/ChooseCreateModal.tsx',
        component: 'Modal',
        parent: 'ChooseCreateModal',
        lineNumber: 42
    },
    {
        backendOwner: 'knowledge-core',
        framework: 'Mantine',
        frontendOwner: 'knowledge-hub',
        filePath: 'pages/search-page/src/components/modals/CreateClassicModal.tsx',
        component: 'Modal',
        parent: 'CreateClassicModal',
        lineNumber: 12
    },
    {
        backendOwner: 'knowledge-core',
        framework: 'Mantine',
        frontendOwner: 'knowledge-hub',
        filePath: 'pages/search-page/src/components/modals/CreateCliModal.tsx',
        component: 'ModalWizard',
        parent: 'CreateCliModal',
        lineNumber: 14
    },
    {
        backendOwner: 'knowledge-core',
        framework: 'Mantine',
        frontendOwner: 'knowledge-hub',
        filePath: 'pages/search-page/src/components/modals/CreateNextGenModal.tsx',
        component: 'Modal',
        parent: 'CreateNextGenModal',
        lineNumber: 92
    },
    {
        backendOwner: 'knowledge-core',
        framework: 'Mantine',
        frontendOwner: 'knowledge-hub',
        filePath: 'pages/search-page/src/components/modals/EditClassicModal.tsx',
        component: 'Modal',
        parent: 'EditClassicModal',
        lineNumber: 34
    },
    {
        backendOwner: 'knowledge-core',
        framework: 'Mantine',
        frontendOwner: 'knowledge-hub',
        filePath: 'pages/search-page/src/components/modals/UpdateCliModal.tsx',
        component: 'Modal',
        parent: 'UpdateCliModal',
        lineNumber: 27
    },
    {
        backendOwner: 'knowledge-core',
        framework: 'Mantine',
        frontendOwner: 'knowledge-hub',
        filePath: 'pages/search-page/src/pages/SearchPagesListingPage.tsx',
        component: 'Page',
        parent: 'SearchPagesListingPage',
        lineNumber: 32
    },
    {
        backendOwner: 'security-cache',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/security-cache/src/components/security-identities-modals/AdditionalStatsModal.tsx',
        component: 'Modal',
        parent: 'AdditionalStatsModalContent',
        lineNumber: 21
    },
    {
        backendOwner: 'security-cache',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/security-cache/src/components/security-identities-modals/EditJsonModal.tsx',
        component: 'Modal',
        parent: 'EditJsonModalContent',
        lineNumber: 47
    },
    {
        backendOwner: 'security-cache',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/security-cache/src/components/security-identities-modals/GlobalStatsModal.tsx',
        component: 'Modal',
        parent: 'GlobalStatsModalContent',
        lineNumber: 18
    },
    {
        backendOwner: 'security-cache',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/security-cache/src/components/security-identities-modals/schedules-modal/SchedulesModal.tsx',
        component: 'Modal',
        parent: 'ScheduleModalContent',
        lineNumber: 18
    },
    {
        backendOwner: 'security-cache',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/security-cache/src/pages/ExploreIdentitiesPage.tsx',
        component: 'Page',
        parent: 'ExploreIdentitiesPage',
        lineNumber: 27
    },
    {
        backendOwner: 'security-cache',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/security-cache/src/pages/SecurityIdentitiesPage.tsx',
        component: 'Page',
        parent: 'SecurityIdentitiesPage',
        lineNumber: 39
    },
    {
        backendOwner: 'platform-resource-insight',
        framework: [
            'Mantine',
            'PlasmaReact'
        ],
        frontendOwner: 'platform-resource-insight',
        filePath: 'pages/snapshot/src/components/apply/modals/ReviewChangesModal.tsx',
        component: 'Modal',
        parent: 'ReviewChangesModal',
        lineNumber: 102
    },
    {
        backendOwner: 'platform-resource-insight',
        framework: 'Mantine',
        frontendOwner: 'platform-resource-insight',
        filePath: 'pages/snapshot/src/components/create/modals/create-snapshot-from-file/CreateSnapshotFromFileModal.tsx',
        component: 'Modal',
        parent: 'CreateSnapshotFromFileModal',
        lineNumber: 29
    },
    {
        backendOwner: 'platform-resource-insight',
        framework: 'Mantine',
        frontendOwner: 'platform-resource-insight',
        filePath: 'pages/snapshot/src/components/list/modals/ResourcesRetrievalErrorModal.tsx',
        component: 'Modal',
        parent: 'ResourcesRetrievalErrorModal',
        lineNumber: 26
    },
    {
        backendOwner: 'platform-resource-insight',
        framework: 'Mantine',
        frontendOwner: 'platform-resource-insight',
        filePath: 'pages/snapshot/src/components/list/modals/export-snapshot/ExportSnapshotModal.tsx',
        component: 'Modal',
        parent: 'ExportSnapshotModal',
        lineNumber: 69
    },
    {
        backendOwner: 'platform-resource-insight',
        framework: 'Mantine',
        frontendOwner: 'platform-resource-insight',
        filePath: 'pages/snapshot/src/components/table/ErrorDetailsModal.tsx',
        component: 'Modal',
        parent: 'ErrorDetailsModal',
        lineNumber: 32
    },
    {
        backendOwner: 'platform-resource-insight',
        framework: [
            'Mantine',
            'PlasmaReact'
        ],
        frontendOwner: 'platform-resource-insight',
        filePath: 'pages/snapshot/src/pages/SnapshotApplyPage.tsx',
        component: 'Page',
        parent: 'SnapshotApplyPage',
        lineNumber: 17
    },
    {
        backendOwner: 'platform-resource-insight',
        framework: 'Mantine',
        frontendOwner: 'platform-resource-insight',
        filePath: 'pages/snapshot/src/pages/SnapshotCreationPage.tsx',
        component: 'Page',
        parent: 'SnapshotCreationPage',
        lineNumber: 9
    },
    {
        backendOwner: 'platform-resource-insight',
        framework: 'Mantine',
        frontendOwner: 'platform-resource-insight',
        filePath: 'pages/snapshot/src/pages/SnapshotViewPage.tsx',
        component: 'Page',
        parent: 'SnapshotViewPage',
        lineNumber: 9
    },
    {
        backendOwner: 'connectivity-core',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/source/src/components/add/add-source-modal/AddSourceModal.tsx',
        component: 'Modal',
        parent: 'AddSourceModal',
        lineNumber: 132
    },
    {
        backendOwner: 'connectivity-core',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/source/src/components/add/suggest-source-modal/SuggestSourceModal.tsx',
        component: 'Modal',
        parent: 'SuggestSourceModal',
        lineNumber: 33
    },
    {
        backendOwner: 'connectivity-core',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/source/src/components/add/upgrade-license-modal/UpgradeLicenseModal.tsx',
        component: 'Modal',
        parent: 'UpgradeLicenseModal',
        lineNumber: 165
    },
    {
        backendOwner: 'generic-connectivity',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/source/src/components/edit/amazon-s3/AmazonS3Source.tsx',
        component: 'SplitLayout',
        parent: 'AmazonS3Source',
        lineNumber: 14
    },
    {
        backendOwner: 'native-connectivity',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/source/src/components/edit/box-business/EditBoxBusinessSource.tsx',
        component: 'SplitLayout',
        parent: 'EditBoxBusinessSource',
        lineNumber: 16
    },
    {
        backendOwner: 'data-integration',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/source/src/components/edit/catalog/EditCatalogSource.tsx',
        component: 'SplitLayout',
        parent: 'EditCatalogSource',
        lineNumber: 8
    },
    {
        backendOwner: 'native-connectivity',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/source/src/components/edit/confluence/cloud/CreateConfluenceSource.tsx',
        component: 'CreationModalLayout',
        parent: 'CreateConfluenceSource',
        lineNumber: 23
    },
    {
        backendOwner: 'native-connectivity',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/source/src/components/edit/confluence/cloud/EditConfluenceSource.tsx',
        component: 'SubnavLayout',
        parent: 'EditConfluenceSource',
        lineNumber: 51
    },
    {
        backendOwner: 'native-connectivity',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/source/src/components/edit/confluence/server/CreateConfluenceServerSource.tsx',
        component: 'CreationModalLayout',
        parent: 'CreateConfluenceServerSource',
        lineNumber: 13
    },
    {
        backendOwner: 'native-connectivity',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/source/src/components/edit/confluence/server/EditConfluenceServerSource.tsx',
        component: 'SubnavLayout',
        parent: 'EditConfluenceServerSource',
        lineNumber: 143
    },
    {
        backendOwner: 'generic-connectivity',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/source/src/components/edit/database/EditDatabaseSource.tsx',
        component: 'SubnavLayout',
        parent: 'EditDatabaseSource',
        lineNumber: 76
    },
    {
        backendOwner: 'generic-connectivity',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/source/src/components/edit/file/EditFileSource.tsx',
        component: 'SplitLayout',
        parent: 'EditFileSource',
        lineNumber: 16
    },
    {
        backendOwner: 'connectivity-core',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/source/src/components/edit/generic-rest/EditGenericRestSource.tsx',
        component: 'SubnavLayout',
        parent: 'EditGenericRestSource',
        lineNumber: 26
    },
    {
        backendOwner: 'native-connectivity',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/source/src/components/edit/google-drive/EditGoogleDriveSource.tsx',
        component: 'SubnavLayout',
        parent: 'EditGoogleDriveSource',
        lineNumber: 26
    },
    {
        backendOwner: 'native-connectivity',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/source/src/components/edit/jira/cloud/CreateJiraSource.tsx',
        component: 'CreationModalLayout',
        parent: 'CreateJiraSource',
        lineNumber: 23
    },
    {
        backendOwner: 'native-connectivity',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/source/src/components/edit/jira/cloud/EditJiraSource.tsx',
        component: 'SubnavLayout',
        parent: 'EditJiraSource',
        lineNumber: 51
    },
    {
        backendOwner: 'native-connectivity',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/source/src/components/edit/jira/server/CreateJiraServerSource.tsx',
        component: 'CreationModalLayout',
        parent: 'CreateJiraServerSource',
        lineNumber: 13
    },
    {
        backendOwner: 'native-connectivity',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/source/src/components/edit/jira/server/EditJiraServerSource.tsx',
        component: 'SubnavLayout',
        parent: 'EditJiraServerSource',
        lineNumber: 135
    },
    {
        backendOwner: 'native-connectivity',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/source/src/components/edit/khoros/CreateKhorosCommunitySource.tsx',
        component: 'CreationModalLayout',
        parent: 'CreateKhorosCommunitySource',
        lineNumber: 8
    },
    {
        backendOwner: 'native-connectivity',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/source/src/components/edit/khoros/EditKhorosCommunitySource.tsx',
        component: 'SubnavLayout',
        parent: 'EditKhorosCommunitySource',
        lineNumber: 28
    },
    {
        backendOwner: 'data-integration',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/source/src/components/edit/push/EditPushSource.tsx',
        component: 'SplitLayout',
        parent: 'EditPushSource',
        lineNumber: 8
    },
    {
        backendOwner: 'generic-connectivity',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/source/src/components/edit/rss/EditRssSource.tsx',
        component: 'SplitLayout',
        parent: 'EditRssSource',
        lineNumber: 15
    },
    {
        backendOwner: 'native-connectivity',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/source/src/components/edit/salesforce/EditSalesforceSource.tsx',
        component: 'SubnavLayout',
        parent: 'EditSalesforceSource',
        lineNumber: 51
    },
    {
        backendOwner: 'native-connectivity',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/source/src/components/edit/sharepoint/EditSharePointSource.tsx',
        component: 'SubnavLayout',
        parent: 'EditSharePointSource',
        lineNumber: 30
    },
    {
        backendOwner: 'native-connectivity',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/source/src/components/edit/sharepoint-online/EditSharePointOnlineSource.tsx',
        component: 'SubnavLayout',
        parent: 'EditSharePointOnlineSource',
        lineNumber: 51
    },
    {
        backendOwner: 'native-connectivity',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/source/src/components/edit/shopify/CreateShopifySource.tsx',
        component: 'NoCreationModalLayout',
        parent: 'CreateShopifySource',
        lineNumber: 5
    },
    {
        backendOwner: 'native-connectivity',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/source/src/components/edit/shopify/EditShopifySource.tsx',
        component: 'SplitLayout',
        parent: 'EditShopifySource',
        lineNumber: 7
    },
    {
        backendOwner: 'generic-connectivity',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/source/src/components/edit/sitecore/CreateSitecoreSource.tsx',
        component: 'NoCreationModalLayout',
        parent: 'CreateSitecoreSource',
        lineNumber: 5
    },
    {
        backendOwner: 'generic-connectivity',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/source/src/components/edit/sitecore/EditSitecoreSource.tsx',
        component: 'SplitLayout',
        parent: 'EditSitecoreSource',
        lineNumber: 7
    },
    {
        backendOwner: 'generic-connectivity',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/source/src/components/edit/sitemap/CreateSitemapSource.tsx',
        component: 'CreationModalLayout',
        parent: 'CreateSitemapSource',
        lineNumber: 12
    },
    {
        backendOwner: 'generic-connectivity',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/source/src/components/edit/sitemap/EditSitemapSource.tsx',
        component: 'SubnavLayout',
        parent: 'EditSitemapSource',
        lineNumber: 91
    },
    {
        backendOwner: 'native-connectivity',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/source/src/components/edit/slack/CreateSlackSource.tsx',
        component: 'CreationModalLayout',
        parent: 'CreateSlackSource',
        lineNumber: 8
    },
    {
        backendOwner: 'native-connectivity',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/source/src/components/edit/slack/EditSlackSource.tsx',
        component: 'SubnavLayout',
        parent: 'EditSlackSource',
        lineNumber: 33
    },
    {
        backendOwner: 'generic-connectivity',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/source/src/components/edit/web/CreateWebSource.tsx',
        component: 'CreationModalLayout',
        parent: 'CreateWebSource',
        lineNumber: 15
    },
    {
        backendOwner: 'generic-connectivity',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/source/src/components/edit/web/EditWebSource.tsx',
        component: 'SubnavLayout',
        parent: 'EditWebSource',
        lineNumber: 127
    },
    {
        backendOwner: 'native-connectivity',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/source/src/components/edit/youtube/EditYoutubeSource.tsx',
        component: 'SplitLayout',
        parent: 'EditYoutubeSource',
        lineNumber: 7
    },
    {
        backendOwner: 'native-connectivity',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/source/src/components/edit/zendesk/CreateZendeskSource.tsx',
        component: 'CreationModalLayout',
        parent: 'CreateZendeskSource',
        lineNumber: 8
    },
    {
        backendOwner: 'native-connectivity',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/source/src/components/edit/zendesk/EditZendeskSource.tsx',
        component: 'SubnavLayout',
        parent: 'EditZendeskSource',
        lineNumber: 30
    },
    {
        backendOwner: 'connectivity-core',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/source/src/components/edit-json/EditJsonModal.tsx',
        component: 'Modal',
        parent: 'EditJsonModal',
        lineNumber: 166
    },
    {
        backendOwner: 'connectivity-core',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/source/src/components/mapping/item-type/ItemTypeModal.tsx',
        component: 'Modal',
        parent: 'ItemTypeModal',
        lineNumber: 47
    },
    {
        backendOwner: 'connectivity-core',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/source/src/components/schedule-operations-modal/ScheduleOperationsModal.tsx',
        component: 'Modal',
        parent: 'ScheduleOperationsModalContent',
        lineNumber: 42
    },
    {
        backendOwner: 'connectivity-core',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/source/src/pages/AddSourcePage.tsx',
        component: 'Page',
        parent: 'AddSourcePage',
        lineNumber: 18
    },
    {
        backendOwner: 'connectivity-core',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/source/src/pages/SourcesListPage.tsx',
        component: 'Page',
        parent: 'SourcesListPage',
        lineNumber: 15
    },
    {
        backendOwner: 'connectivity-core',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/source-panel-generator/src/building-blocks/authentication-block/forms/AccessTokenAuthenticationEditModal.tsx',
        component: 'Modal',
        parent: 'AccessTokenAuthenticationEditModal',
        lineNumber: 70
    },
    {
        backendOwner: 'generic-connectivity',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/source-panel-generator/src/building-blocks/authentication-block/forms/custom-login-sequence/CustomLoginSequenceStepModal.tsx',
        component: 'Modal',
        parent: 'CustomLoginSequenceStepModal',
        lineNumber: 140
    },
    {
        backendOwner: 'generic-connectivity',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/source-panel-generator/src/building-blocks/web-scraping-block/configuration-modal/WebScrapingConfigurationModal.tsx',
        component: 'Modal',
        parent: 'WebScrapingConfigurationModal',
        lineNumber: 55
    },
    {
        backendOwner: 'generic-connectivity',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/source-panel-generator/src/building-blocks/web-scraping-block/json-modal/WebScrapingJsonModal.tsx',
        component: 'Modal',
        parent: 'WebScrapingJsonModal',
        lineNumber: 55
    },
    {
        backendOwner: 'connectivity-core',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/source-panel-generator/src/building-tabs/content-security-tab/specific-permissions/AddEditPermissionModal.tsx',
        component: 'Modal.Root',
        parent: 'AddEditPermissionModal',
        lineNumber: 161
    },
    {
        backendOwner: 'index-querying',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/source-panel-generator/src/building-tabs/items-tab/edit-modal/EditSettingModal.tsx',
        component: 'Modal',
        parent: 'EditSettingModal',
        lineNumber: 22
    },
    {
        backendOwner: 'connectivity-core',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/source-panel-generator/src/layouts/PrivilegesLayout.tsx',
        component: 'Page',
        parent: 'PrivilegesLayout',
        lineNumber: 69
    },
    {
        backendOwner: 'connectivity-core',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/source-panel-generator/src/test-utils/layouts/TestLayout.tsx',
        component: 'Page',
        parent: 'TestLayout',
        lineNumber: 26
    },
    {
        backendOwner: 'connectivity-core',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/source-panel-generator/src/v2/layouts/creation-modal-layout/CreationModalLayoutInner.tsx',
        component: 'Modal',
        parent: 'CreationModalLayoutInner',
        lineNumber: 174
    },
    {
        backendOwner: 'connectivity-core',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/source-panel-generator/src/v2/layouts/no-creation-modal-layout/NoCreationModalLayoutInner.tsx',
        component: 'Modal',
        parent: 'NoCreationModalLayoutInner',
        lineNumber: 32
    },
    {
        backendOwner: 'native-connectivity',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/source-panel-generator/src/v2/panel-elements/objects-and-fields-to-index-block/body-mapping-action/BodyMappingAction.tsx',
        component: 'Modal',
        parent: 'BodyMappingModal',
        lineNumber: 28
    },
    {
        backendOwner: 'native-connectivity',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/source-panel-generator/src/v2/panel-elements/objects-and-fields-to-index-block/condition-action/ConditionAction.tsx',
        component: 'Modal',
        parent: 'ConditionModal',
        lineNumber: 23
    },
    {
        backendOwner: 'commerce-implement',
        framework: 'Mantine',
        frontendOwner: 'commerce-implement',
        filePath: 'pages/storefront-associations/src/pages/StorefrontAssociationCreationPage.tsx',
        component: 'Page',
        parent: 'StorefrontAssociationCreationPage',
        lineNumber: 7
    },
    {
        backendOwner: 'commerce-implement',
        framework: 'Mantine',
        frontendOwner: 'commerce-implement',
        filePath: 'pages/storefront-associations/src/pages/StorefrontAssociationEditPage.tsx',
        component: 'Page',
        parent: 'StorefrontAssociationEditPage',
        lineNumber: 36
    },
    {
        backendOwner: 'commerce-implement',
        framework: 'Mantine',
        frontendOwner: 'commerce-implement',
        filePath: 'pages/storefront-associations/src/pages/StorefrontAssociationOverviewPage.tsx',
        component: 'Page',
        parent: 'StorefrontAssociationOverviewPage',
        lineNumber: 32
    },
    {
        backendOwner: 'commerce-implement',
        framework: 'Mantine',
        frontendOwner: 'commerce-implement',
        filePath: 'pages/storefront-associations/src/pages/StorefrontAssociationPage.tsx',
        component: 'Page',
        parent: 'StorefrontAssociationPage',
        lineNumber: 27
    },
    {
        backendOwner: 'platform-identity-and-entitlements',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/system-performance/src/pages/SystemPerformancePage.tsx',
        component: 'Page',
        parent: 'SystemPerformancePage',
        lineNumber: 32
    },
    {
        backendOwner: 'dataplatformfoundation',
        framework: 'Mantine',
        frontendOwner: 'platform-solution-experience',
        filePath: 'pages/visit-browser/src/pages/VisitBrowserPage.tsx',
        component: 'Page',
        parent: 'VisitBrowserPage',
        lineNumber: 6
    },
    {
        backendOwner: 'frontend-foundation',
        framework: 'Mantine',
        frontendOwner: 'frontend-foundation',
        filePath: 'apps/commerce-hub/src/applications/MainApplication.tsx',
        component: 'App',
        parent: 'MainApplication',
        lineNumber: 33
    },
    {
        backendOwner: 'frontend-foundation',
        framework: 'Mantine',
        frontendOwner: 'frontend-foundation',
        filePath: 'apps/commerce-hub/src/pages/NotFoundPage.tsx',
        component: 'Page',
        parent: 'NotFoundPage',
        lineNumber: 15
    },
    {
        backendOwner: 'frontend-foundation',
        framework: 'Mantine',
        frontendOwner: 'frontend-foundation',
        filePath: 'apps/knowledge-hub/src/applications/MainApplication.tsx',
        component: 'App',
        parent: 'MainApplication',
        lineNumber: 20
    },
    {
        backendOwner: 'frontend-foundation',
        framework: 'Mantine',
        frontendOwner: 'frontend-foundation',
        filePath: 'apps/knowledge-hub/src/pages/NotFoundPage.tsx',
        component: 'Page',
        parent: 'NotFoundPage',
        lineNumber: 15
    },
    {
        backendOwner: 'frontend-foundation',
        framework: 'Mantine',
        frontendOwner: 'frontend-foundation',
        filePath: 'apps/platform/src/applications/MainApplication.tsx',
        component: 'App',
        parent: 'MainApplication',
        lineNumber: 40
    }
];

//# sourceMappingURL=FileOwnership.js.map